export const translations = {
  fr: {
    'common.loading': 'Chargement…',
    'common.back': 'Retour',
    'common.backHome': "Retour à l'accueil",
    'common.home': 'Accueil',
    'common.sending': 'Envoi…',
    'common.cancel': 'Annuler',
    'common.error': 'Une erreur est survenue',
    'common.support': 'Soutenir le projet',
    'common.chapter': 'chapitre',
    'common.chapters': 'chapitres',
    'common.chapterN': 'Chapitre {n}',
    'nav.chapters': 'Mon aventure',
    'nav.diary': 'Mon carnet',
    'nav.synthesis': 'Mon parcours',
    'nav.parent': 'Mon enfant',
    'nav.educator': 'Mon groupe',
    'nav.admin': 'Back-office',
    'nav.crm': 'CRM',
    'footer.book': 'Le livre',
    'footer.media': 'Médias',
    'footer.masterclass': 'Rendez-vous OCQJ !',
    'footer.about': 'À propos',
    'footer.access': 'Demander un accès',
    'footer.rgpd': 'Conforme RGPD — carnet des jeunes chiffré.',
    'roles.jeune': 'Jeune',
    'roles.parent': 'Parent',
    'roles.educateur': 'Éducateur',
    'roles.admin': 'Administrateur',
    'axes.coeur': 'Émotions',
    'axes.sagesse': 'Sagesse',
    'axes.phrase': 'Inspiration',
    'axes.mentor': 'Mentorat',
    'axes.dialogue': 'Dialogue',
    'axes.mission': 'Action',
    'axes.carnet': 'Introspection',
    'axes.giveback': 'Transmission',
    'axes.aventure': 'Ouverture',
    'axes.projection': 'Projection',
    'badges.premier-pas.label': 'Premier pas',
    'badges.premier-pas.hint': 'Terminer le chapitre 1',
    'badges.je-me-connais.label': 'Je me connais',
    'badges.je-me-connais.hint': 'Écrire 3 réflexions dans ton carnet',
    'badges.je-me-releve.label': 'Je me relève',
    'badges.je-me-releve.hint': "Terminer le chapitre 12 — l'échec est un professeur",
    'badges.esprit-equipe.label': "Esprit d'équipe",
    'badges.esprit-equipe.hint': 'Réaliser 3 dialogues',
    'badges.mission-accomplie.label': 'Mission accomplie',
    'badges.mission-accomplie.hint': "Accomplir ta première mission d'Eliano",
    'badges.je-remercie.label': 'Je remercie',
    'badges.je-remercie.hint': 'Terminer le chapitre 23 — la promesse à tes parents',
    'badges.je-transmets.label': 'Je transmets',
    'badges.je-transmets.hint': 'Réaliser ton premier Give Back',
    'badges.give-back.label': 'Give Back',
    'badges.give-back.hint': 'Réaliser 3 actions de transmission',
    'badges.leader-positif.label': 'Leader positif',
    'badges.leader-positif.hint': 'Terminer le chapitre 20 — le champion commence ici',
    'badges.heritage.label': 'Héritage',
    'badges.heritage.hint': 'Terminer les 28 chapitres — le relais est à toi',
    'landing.login': "J'ai déjà un compte",
    'landing.eyebrow': "Le prix du rêve sportif — l'aventure d'Eliano",
    'landing.titleA': "L'aventure continue ",
    'landing.titleB': 'après la dernière page.',
    'landing.intro': "Le livre raconte l'histoire d'Eliano. La plateforme te la fait vivre : 28 chapitres, 10 clés par chapitre, ta Roue de l'Héritage et ton carnet secret.",
    'landing.codeLabel': "Entre le code de ton livre ou ton code d'invitation",
    'landing.codePlaceholder': 'ex : OCQJ-XXXX-XXXX',
    'landing.submit': "Entrer dans l'aventure",
    'landing.checking': 'Vérification…',
    'landing.codeInvalid': 'Code invalide',
    'landing.qrHint': 'Le QR code de ton livre ouvre directement le chapitre correspondant.',
    'landing.noCode': "Tu n'as pas de code ? Demande ton accès →",
    'landing.communityPrefix': 'Déjà',
    'landing.communitySuffix': 'par la communauté',
    'landing.givebackOne': 'Give Back réalisé',
    'landing.givebackMany': 'Give Backs réalisés',
    'landing.missionOne': 'mission réalisée',
    'landing.missionMany': 'missions réalisées',
    'landing.and': 'et',
    'landing.f1t': "Les 10 clés de l'Héritage",
    'landing.f1d': 'Émotions, sagesse, mentor, mission, Give Back… chaque chapitre devient une expérience à vivre.',
    'landing.f2t': "Ta Roue de l'Héritage",
    'landing.f2d': 'Un radar à 10 branches qui grandit avec tes actions — jamais une note, toujours une aventure.',
    'landing.f3t': "Le carnet d'Eliano",
    'landing.f3d': "Lis ce qu'Eliano écrit, puis écris ta propre histoire dans ton carnet chiffré et privé.",
    'landing.security': "Espace sécurisé pour les jeunes : compte activé avec l'autorisation d'un parent. Carnet chiffré.",
    'landing.supportCta': 'Soutenir le projet sur Ulule',
    'landing.hero.title': "ON CROIT QU'ON JOUE !",
    'landing.hero.subtitle': 'Le Prix du Rêve Sportif',
    'landing.hero.baseline': "Du rêve personnel à l'héritage collectif",
    'landing.hero.quote': "« Peut-on devenir un grand champion sans d'abord devenir une belle personne ? »",
    'landing.acts.title': 'Les 4 actes du livre',
    'landing.acts.1.title': 'Acte 1 : Le Rêve',
    'landing.acts.1.desc': "L'étincelle initiale, la naissance d'une vocation qui transcende le quotidien.",
    'landing.acts.2.title': 'Acte 2 : Les Épreuves',
    'landing.acts.2.desc': "L'apprentissage par l'adversité : grandir et se forger dans la difficulté.",
    'landing.acts.3.title': 'Acte 3 : Les Choix',
    'landing.acts.3.desc': 'Prendre les rênes de son destin, construire un avenir éclairé par ses valeurs.',
    'landing.acts.4.title': 'Acte 4 : La Transmission',
    'landing.acts.4.desc': "Le véritable héritage d'un champion : ce qu'il lègue à la génération suivante.",
    'landing.pillars.title': "Bien plus qu'un roman : une expérience inédite",
    'landing.pillars.1.title': 'Roman illustré',
    'landing.pillars.1.desc': '28 chapitres immersifs au cœur de la quête de soi.',
    'landing.pillars.2.title': 'Parcours pédagogique',
    'landing.pillars.2.desc': "Défis, questions et réflexions pour accompagner l'évolution.",
    'landing.pillars.3.title': 'Plateforme interactive',
    'landing.pillars.3.desc': 'Une plateforme numérique inédite : clés de réflexion, carnet de rêves et ressources exclusives pour jeunes, parents et éducateurs.',
    'landing.pillars.4.title': 'Musique & audio',
    'landing.pillars.4.desc': "Une bande-son originale composée pour le livre, à écouter pendant la lecture — une première dans le roman jeunesse.",
    'landing.pillars.5.title': 'Étude sur le rêve',
    'landing.pillars.5.desc': "Une analyse profonde des rouages de l'ambition sportive.",
    'landing.pillars.6.title': 'Rendez-vous OCQJ !',
    'landing.pillars.6.desc': "Des moments d'échange et de partage pour grandir ensemble.",
    'landing.audio.title': 'La bande-son du livre',
    'landing.audio.desc': "Une innovation : le livre a sa propre musique. Écoutez ces deux extraits et plongez dans l'aventure avant même de tourner la première page.",
    'landing.audio.track1': 'Extrait n°1',
    'landing.audio.track2': 'Extrait n°2',
    'landing.audio.soon': 'Bientôt disponible — en cours de finalisation.',
    'landing.mc.title': 'Rendez-vous OCQJ ! — 4 rencontres en ligne',
    'landing.mc.subtitle': 'Pour découvrir, échanger et construire ensemble : quatre soirées Zoom ouvertes, une heure chacune.',
    'landing.mc.ev1.date': 'Lundi 7 sept. 2026 · 20h00–21h00',
    'landing.mc.ev1.audience': 'Presse & Médias',
    'landing.mc.ev1.objective': 'Faire découvrir le projet aux médias et créer les premiers relais de presse.',
    'landing.mc.ev1.subject': "Et si le football était d'abord une école de la vie ?",
    'landing.mc.ev2.date': 'Lundi 14 sept. 2026 · 20h00–21h00',
    'landing.mc.ev2.audience': 'Partenaires & Écosystème football',
    'landing.mc.ev2.objective': 'Réunir les premiers bâtisseurs : clubs, institutions, marques et fondations.',
    'landing.mc.ev2.subject': 'Je vous fais une passe. À vous de la transformer.',
    'landing.mc.ev3.date': 'Lundi 21 sept. 2026 · 20h00–21h00',
    'landing.mc.ev3.audience': 'Parents & Éducateurs',
    'landing.mc.ev3.objective': "Créer l'adhésion des parents et éducateurs autour de la dimension éducative.",
    'landing.mc.ev3.subject': "Comment accompagner le rêve d'un jeune sans s'y perdre ?",
    'landing.mc.ev4.date': 'Lundi 28 sept. 2026 · 20h00–21h00',
    'landing.mc.ev4.audience': 'Jeunes & Parents',
    'landing.mc.ev4.objective': "Faire entrer les jeunes et leurs familles dans l'univers d'Eliano.",
    'landing.mc.ev4.subject': 'Et toi, quel est ton rêve ?',
    'landing.mc.zoomTitle': 'Connexion Zoom — le même lien pour les 4 rendez-vous',
    'landing.mc.zoomId': 'ID de réunion : 856 9303 8418 · Code secret : 531726',
    'landing.mc.cta': 'Rejoindre la réunion Zoom',
    'landing.action_band.1': 'LIRE',
    'landing.action_band.2': 'COMPRENDRE',
    'landing.action_band.3': 'AGIR',
    'landing.action_band.4': 'TRANSMETTRE',
    'landing.masterclass.title': 'Les Rendez-vous OCQJ !',
    'landing.masterclass.subtitle': 'Rencontre participative (60 à 90 min)',
    'landing.masterclass.points.1': 'Rêver sans se perdre',
    'landing.masterclass.points.2': "Apprendre de l'échec",
    'landing.masterclass.points.3': 'Construire sa discipline',
    'landing.masterclass.points.4': 'Choisir son entourage',
    'landing.masterclass.points.5': "Préparer l'après-football",
    'landing.masterclass.points.6': 'Leadership & transmission',
    'landing.crowdfunding.title': 'Campagne Ulule',
    'landing.crowdfunding.subtitle': 'Du 4 septembre au 7 novembre 2026',
    'landing.crowdfunding.desc': "Participez au lancement d'On croit qu'on joue ! et accédez à des contreparties exclusives.",
    'landing.crowdfunding.points.1': 'Livres & ressources éducatives',
    'landing.crowdfunding.points.2': 'Rendez-vous OCQJ ! & Give Back',
    'landing.crowdfunding.points.3': 'Audio, vidéo & communauté engagée',
    'landing.giveback.title': 'Le Give Back',
    'landing.giveback.desc': "Transmettre, partager, inclure. Nous offrons des livres et des ressources aux jeunes qui en ont le plus besoin, avec les clubs et les partenaires.",
    'landing.batisseurs.title': 'Je cherche des bâtisseurs',
    'landing.batisseurs.desc': "Partenaires, clubs, éducateurs, parents, entreprises… Rejoignez une aventure utile pour la jeunesse.",
    'landing.batisseurs.cta': 'Devenir partenaire',
    'landing.batisseurs.dossier': 'Dossier de partenariat (PDF)',
    'landing.lead.profile.club': 'Un club de foot',
    'landing.author.name': "Dimitri M'Foumou-Titi",
    'landing.author.role': 'Auteur',
    'landing.author.quote': "« Ensemble, faisons du football une école de vie et un héritage collectif ! »",
    'landing.closing': "Soutenir le projet, c'est contribuer à écrire l'avenir de nos jeunes.",
    'landing.lead.title': "Envie de suivre l'aventure ?",
    'landing.lead.desc': "Laissez vos coordonnées : vous recevrez en avant-première les actualités du livre, des Rendez-vous OCQJ et du lancement.",
    'landing.lead.titleM': 'Le site arrive très bientôt !',
    'landing.lead.descM': "Nous préparons la plateforme. Laissez vos coordonnées : vous serez prévenu en avant-première du lancement, du livre et des Rendez-vous OCQJ.",
    'maintenance.badge': 'Maintenance en cours',
    'maintenance.title': 'On revient très vite !',
    'maintenance.subtitle': "Le site est momentanément en maintenance. En attendant, découvrez la vidéo du projet et laissez-nous votre email pour être prévenu du lancement.",
    'landing.lead.name': 'Votre prénom et nom',
    'landing.lead.email': 'Votre email',
    'landing.lead.profileLabel': 'Vous êtes…',
    'landing.lead.profile.lecteur': 'Futur lecteur',
    'landing.lead.profile.parent': 'Parent',
    'landing.lead.profile.journaliste': 'Journaliste',
    'landing.lead.profile.joueur': 'Joueur·euse',
    'landing.lead.profile.partenaire': 'Partenaire',
    'landing.lead.profile.ambassadeur': 'Ambassadeur·rice',
    'landing.lead.interestLabel': 'Ce qui vous intéresse',
    'landing.lead.interest.livre': 'Le livre',
    'landing.lead.interest.masterclass': 'Un Rendez-vous OCQJ !',
    'landing.lead.interest.les_deux': 'Les deux',
    'landing.lead.submit': 'Me tenir informé·e',
    'landing.lead.success': "Merci ! Vous faites partie de l'aventure — à très vite.",
    'landing.lead.rgpd': 'Vos données servent uniquement à vous informer. Désinscription en un clic, à tout moment.',
    'landing.lead.error': 'Une erreur est survenue — réessayez.',
    'landing.lead.hasCode': 'Tu as déjà le livre ? Entre ton code →',
    'landing.lead.backToForm': "← Revenir au formulaire d'information",
    'landing.videoTitle': "L'aventure en vidéo",
    'footer.privacy': 'Confidentialité',
    'footer.legal': 'Mentions légales',
    'footer.press': 'Presse',
    'press.eyebrow': 'Espace médias',
    'press.title': 'Presse & visuels officiels',
    'press.intro': "Retrouvez ici les visuels officiels du projet « On croit qu'on joue ! — Le Prix du Rêve Sportif », libres d'utilisation pour vos articles et publications (crédit : Dimitri M'Foumou-Titi).",
    'press.visual1': 'Flyer « Masterclass inspirantes »',
    'press.visual2': 'Bannière officielle du projet',
    'press.visual3': 'Couverture du roman',
    'press.visual4': "Portrait de l'auteur",
    'press.download': 'Télécharger',
    'press.ficheAuteur': 'Télécharger la fiche auteur',
    'press.contactTitle': 'Contact presse',
    'press.docsTitle': 'Documents officiels',
    'press.visualsTitle': 'Visuels officiels',
    'press.doc1': 'Dossier de partenariat',
    'press.doc2': 'Dossier de presse',
    'press.doc3': 'Guide parents & jeunes joueurs',
    'press.doc4': 'Cartes réseaux sociaux',
    'press.aud1': 'Partenaires',
    'press.aud2': 'Presse',
    'press.aud3': 'Parents & jeunes',
    'press.aud4': 'Réseaux sociaux',
    'media.docsTitle': 'Documents à télécharger',
    'legal.eyebrow': 'Informations légales',
    'legal.title': 'Mentions légales',
    'legal.intro': "Dernière mise à jour : juin 2026. Informations légales relatives au site et à la plateforme « On croit qu'on joue ! — Le Prix du Rêve Sportif ».",
    'legal.s1Title': '1. Éditeur du site',
    'legal.s1Body': "Dimitri M'Foumou-Titi, auteur et éditeur du projet « On croit qu'on joue ! » (entrepreneur individuel).\nSIREN : 991 741 075 — SIRET : 991 741 075 00014 — Code APE : 90.03B (autre création artistique).\nImmatriculé au Registre National des Entreprises le 23/09/2025.\nSiège social : 4 Cité Croix Saint-Simon, 78100 Saint-Germain-en-Laye — France.\nContact : dimitri.mfoumou@gmail.com — +33 6 98 69 75 58.",
    'legal.s2Title': '2. Directeur de la publication',
    'legal.s2Body': "Dimitri M'Foumou-Titi.",
    'legal.s3Title': '3. Hébergement',
    'legal.s3Body': "Le site est hébergé sur une infrastructure cloud conteneurisée exploitée par la plateforme de déploiement. Les données sont hébergées de préférence au sein de l'Union européenne.",
    'legal.s4Title': '4. Propriété intellectuelle',
    'legal.s4Body': "L'ensemble des contenus du site et de l'œuvre « On croit qu'on joue ! — Le Prix du Rêve Sportif » (textes, illustrations, identité visuelle, musiques, vidéos) est protégé par le droit d'auteur. Toute reproduction, représentation ou diffusion, totale ou partielle, sans autorisation écrite préalable est interdite.",
    'legal.s5Title': '5. Données personnelles',
    'legal.s5Body': "Le traitement des données personnelles (comptes, progression, carnet chiffré, prospection) est décrit dans la Politique de confidentialité, accessible ci-dessous et depuis le pied de page.",
    'legal.s6Title': '6. Liens externes',
    'legal.s6Body': "Le site contient des liens vers des services tiers (Ulule, YouTube, LinkedIn). L'éditeur n'est pas responsable de leurs contenus ni de leurs pratiques.",
    'legal.s7Title': '7. Droit applicable',
    'legal.s7Body': "Le présent site est soumis au droit français. En cas de litige, et après tentative de résolution amiable, les tribunaux français seront seuls compétents.",
    'privacy.eyebrow': 'RGPD — vos données, vos droits',
    'privacy.title': 'Politique de confidentialité',
    'privacy.intro': "Dernière mise à jour : juin 2026. Cette politique explique quelles données sont traitées par la plateforme « On croit qu'on joue ! — Le Prix du Rêve Sportif » et quels sont vos droits.",
    'privacy.s1Title': '1. Responsable de traitement',
    'privacy.s1Body': "Dimitri M'Foumou-Titi, éditeur du projet « On croit qu'on joue ! ».\nContact : dimitri.mfoumou@gmail.com — +33 6 98 69 75 58.",
    'privacy.s2Title': '2. Données traitées',
    'privacy.s2Body': "Comptes utilisateurs : adresse email, prénom ou pseudo, rôle (jeune, parent, éducateur, admin).\nProgression pédagogique : clés validées, Roue de l'Héritage, badges.\nCarnet personnel du jeune : contenu chiffré (AES-256-GCM), illisible par l'équipe.\nPhotos « Give Back » : publiées uniquement avec l'accord de l'utilisateur.\nProspection : coordonnées professionnelles (contacts importés ou laissés via le formulaire d'accueil), historique des envois et relances.\nJournaux techniques : audit d'administration et limitation de débit (anti-abus).",
    'privacy.s3Title': '3. Finalités',
    'privacy.s3Body': "Fournir la plateforme pédagogique et suivre la progression des jeunes.\nVérifier le consentement parental avant toute activation de compte jeune.\nEnvoyer les communications demandées (livre, Rendez-vous OCQJ) et les campagnes de prospection validées par l'éditeur.\nAssurer la sécurité et la fiabilité du service.",
    'privacy.s4Title': '4. Bases légales',
    'privacy.s4Body': "Exécution du contrat : création de compte et parcours pédagogique.\nConsentement : carnet personnel, photos Give Back, formulaire de contact de l'accueil.\nIntérêt légitime : prospection professionnelle, sécurité, statistiques de fréquentation anonymisées.",
    'privacy.s5Title': '5. Durées de conservation',
    'privacy.s5Body': "Compte : durée de vie du compte, puis 3 ans maximum après la dernière activité.\nCarnet chiffré : supprimé avec le compte, sans copie lisible.\nProspection : 3 ans après le dernier échange ; toute désinscription prend effet immédiatement.\nJournaux techniques : 12 mois maximum.",
    'privacy.s6Title': '6. Sous-traitants',
    'privacy.s6Body': "Hébergement applicatif et base de données (MongoDB), envoi d'emails transactionnels (Resend), stockage sécurisé de fichiers. Nous privilégions des traitements au sein de l'Union européenne.",
    'privacy.s7Title': '7. Vos droits',
    'privacy.s7Body': "Vous disposez de droits d'accès, de rectification, d'effacement, de portabilité, de limitation et d'opposition.\nDepuis « Mon compte » : export JSON de vos données et suppression définitive du compte.\nProspection : lien de désinscription en un clic présent dans chaque email.\nPar email : dimitri.mfoumou@gmail.com. Vous pouvez également saisir la CNIL (cnil.fr).",
    'privacy.s8Title': '8. Protection des mineurs',
    'privacy.s8Body': "Le compte d'un jeune n'est activé qu'après consentement parental vérifiable (lien signé envoyé au parent, valable 72 h).\nLe parent suit la progression de son enfant mais n'a jamais accès à son carnet personnel chiffré.",
    'privacy.s9Title': '9. Sécurité et cookies',
    'privacy.s9Body': "Connexion par code à usage unique envoyé par email : aucun mot de passe n'est stocké.\nFichiers servis par URLs signées (validité 15 minutes), limitation de débit, journal d'audit des actions d'administration.\nAucun cookie tiers ni traceur publicitaire : seules des préférences locales (session, langue) sont enregistrées dans votre navigateur.",
    'book.codeTitle': 'Tu as le livre ? Entre ton code',
    'book.givebackTitle': 'Le Give Back en action',
    'admin.tabSettings': 'Paramètres',
    'admin.setTitle': 'Paramètres du site',
    'admin.setVideo': "Vidéo de la page d'accueil",
    'admin.setVideoHelp': 'Lien YouTube ou fichier .mp4 — affichée à côté du formulaire d\'accueil. Laisser vide pour masquer la vidéo.',
    'admin.settingsSaved': 'Paramètres enregistrés !',
    'admin.setPages': 'Pages publiques (activation)',
    'admin.setAudio1': 'Extrait audio 1 (fichier MP3)',
    'admin.setAudio2': 'Extrait audio 2 (fichier MP3)',
    'admin.setAudioHelp': "Collez un chemin local ou une URL https, ou importez le fichier MP3 depuis votre ordinateur avec le bouton (25 Mo max). Les extraits apparaissent dans la section « Bien plus qu'un roman » de la landing.",
    'admin.audioUpload': 'Importer un MP3',
    'admin.audioTitlePh': 'Titre du morceau affiché sur la landing (ex. : Le Chant du terrain)',
    'admin.audioUploaded': 'Fichier importé ! Cliquez sur Enregistrer pour l’appliquer.',
    'admin.audioInvalid': 'Seuls les fichiers .mp3 sont acceptés',
    'admin.audioTooBig': 'Fichier trop volumineux (25 Mo max)',
    'admin.mcEventsTitle': 'Rendez-vous OCQJ ! — 4 rencontres en ligne (landing)',
    'admin.mcEventsHelp': "Vide = texte par défaut (traduit FR/EN/ES). Votre saisie remplace le texte affiché. La visibilité de la section suit l'interrupteur « Rendez-vous OCQJ ! » des pages publiques ci-dessus.",
    'admin.mcEvTitle': 'Rendez-vous n°{n}',
    'admin.analyticsTitle': 'Analytics de la plateforme',
    'admin.an.users': 'Comptes actifs',
    'admin.an.pendingConsent': 'En attente de consentement',
    'admin.an.signups7': 'Inscriptions (7 j)',
    'admin.an.signups30': 'Inscriptions (30 j)',
    'admin.an.chapters': 'Chapitres terminés',
    'admin.an.keys': 'Clés répondues',
    'admin.an.diary': 'Entrées de carnet',
    'admin.an.family': 'Liens familiaux',
    'admin.an.consents': 'Consentements en attente',
    'admin.an.requests': "Demandes d'accès en attente",
    'admin.an.crm': 'Contacts CRM',
    'admin.an.mc': 'Inscriptions Rendez-vous OCQJ',
    'admin.an.messages': 'Messages de contact',
    'admin.an.recent': 'Dernières inscriptions',
    'admin.an.empty': 'Aucune inscription récente',
    'admin.maintenanceMode': 'Mode maintenance',
    'admin.maintenanceHelp': "Quand il est activé, tout le site public affiche un écran de maintenance avec le formulaire « Envie de suivre l'aventure ». Vous restez connecté en tant qu'admin.",
    'admin.setContent': 'Contenus éditables (remplacent les textes par défaut)',
    'admin.contentEmpty': 'Vide = texte par défaut',
    'admin.pageToggle.page_livre': 'Page « Le livre »',
    'admin.pageToggle.page_medias': 'Page « Médias »',
    'admin.pageToggle.page_masterclass': 'Page « Rendez-vous OCQJ ! »',
    'admin.pageToggle.page_apropos': 'Page « À propos »',
    'admin.pageToggle.page_faq': 'Page « FAQ »',
    'admin.pageToggle.page_presse': 'Page « Presse »',
    'admin.pageToggle.page_contact': 'Page « Contact »',
    'admin.contentField.content_landing_quote': "Citation du hero (page d'accueil)",
    'admin.contentField.content_landing_closing': "Bandeau final (page d'accueil)",
    'admin.contentField.content_contact_reply48': 'Promesse de réponse (page Contact)',
    'page.disabled': 'Page temporairement indisponible — revenez très vite !',
    'login.title': 'Connexion',
    'login.email': 'Ton email',
    'login.emailPlaceholder': 'toi@exemple.fr',
    'login.noPassword': "Pas de mot de passe : on t'envoie un code à 6 chiffres par email.",
    'login.requestCode': 'Recevoir mon code',
    'login.codeSent': 'Un code vient d\'être envoyé !',
    'login.sendError': "Impossible d'envoyer le code",
    'login.codeSentTo': 'Un code à 6 chiffres a été envoyé à {email} (valable 10 minutes).',
    'login.devMode': 'Mode démo — code : {code}',
    'login.submit': 'Me connecter',
    'login.invalidCode': 'Code invalide',
    'login.changeEmail': "Changer d'email",
    'login.noAccount': "Aucun compte actif pour cet email. Si ta demande d'accès a été acceptée, clique sur « Créer mon compte » dans l'email reçu : le compte n'existe qu'une fois cette inscription terminée.",
    'login.noAccountCta': 'Demander un accès',
    'login.pendingConsent': "Ton compte attend encore l'autorisation d'un parent : il doit cliquer sur le lien reçu par email pour l'activer.",
    'ambProfile.title': 'Ton profil ambassadeur',
    'ambProfile.intro': "Bienvenue dans la Team Héritage ! Ajoute ta photo et tes réseaux sociaux : ils seront validés par l'équipe.",
    'ambProfile.photoLabel': 'Ta photo',
    'ambProfile.photoChoose': 'Choisir une photo',
    'ambProfile.photoHelp': 'JPG, PNG ou WebP — 5 Mo max.',
    'ambProfile.photoUpload': 'Envoyer la photo',
    'ambProfile.photoUploaded': 'Photo envoyée !',
    'ambProfile.photoInvalid': 'Format accepté : JPG, PNG ou WebP',
    'ambProfile.photoTooBig': 'Photo trop lourde (5 Mo max)',
    'ambProfile.linksTitle': 'Tes réseaux sociaux (facultatif)',
    'ambProfile.linksHelp': '2 liens sont proposés, tu peux en ajouter jusqu\'à 5.',
    'ambProfile.url': 'Lien (https://…)',
    'ambProfile.addLink': 'Ajouter un lien',
    'ambProfile.save': 'Enregistrer mes liens',
    'ambProfile.saved': 'Profil enregistré !',
    'ambProfile.pendingReview': "Profil envoyé : il sera validé par l'équipe.",
    'ambProfile.approved': "Ton profil est validé par l'équipe !",
    'ambProfile.rejected': "Ton profil a été refusé par l'équipe : tu peux le modifier puis le renvoyer.",
    'ambProfile.notFound': "Lien invalide ou expiré. Contacte-nous si tu penses qu'il s'agit d'une erreur.",
    'ambProfile.networks.instagram': 'Instagram',
    'ambProfile.networks.tiktok': 'TikTok',
    'ambProfile.networks.linkedin': 'LinkedIn',
    'ambProfile.networks.youtube': 'YouTube',
    'ambProfile.networks.other': 'Autre',
    'admin.ambassadorProfileTitle': 'Voir le profil (photo + réseaux)',
    'admin.profileReviewTitle': 'Profil ambassadeur',
    'admin.approveProfile': 'Approuver le profil',
    'admin.rejectProfile': 'Refuser le profil',
    'admin.profileApproved': 'Profil approuvé',
    'admin.profileRejected': 'Profil refusé',
    'admin.noProfileYet': 'Aucune photo ni lien pour le moment.',
    'admin.onLanding': 'Profil validé',
    'admin.accessJeuneAuto': 'Validation automatique des demandes « Lecteur·trice »',
    'admin.accessJeuneAutoHelp': "ON : le lien « Créer mon compte » est envoyé immédiatement. OFF : la demande attend votre validation manuelle. Les demandes Parent et Éducateur sont toujours automatiques.",
    'admin.autoBadge': 'Auto',
    'landing.amb.eyebrow': 'Team Héritage',
    'landing.amb.title': 'Nos ambassadeurs',
    'landing.amb.subtitle': "Ils font découvrir l'aventure d'Eliano autour d'eux.",
    'side.upcomingTitle': 'Rendez-vous à venir',
    'side.upcomingEmpty': 'Aucun rendez-vous à venir pour le moment.',
    'side.allEvents': 'Voir tous les rendez-vous',
    'side.newsTitle': 'Actualités en vidéo',
    'side.newsText': "Messages et nouvelles de l'équipe pour tout le réseau.",
    'admin.setNetworkVideo': 'Vidéo actualités du réseau (URL YouTube — affichée dans les espaces connectés)',
    'registerYouth.title': "Rejoins l'aventure d'Eliano",
    'registerYouth.name': 'Ton prénom',
    'registerYouth.namePlaceholder': 'ex : Léa',
    'registerYouth.age': 'Ton âge',
    'registerYouth.agePlaceholder': 'ex : 10',
    'registerYouth.parentEmail': "L'email de ton parent",
    'registerYouth.parentEmailPlaceholder': 'parent@exemple.fr',
    'registerYouth.note': 'Ton parent recevra un email pour autoriser la création de ton compte. Ton carnet personnel restera secret, même pour lui.',
    'registerYouth.submit': "Demander l'autorisation",
    'registerYouth.successTitle': 'Presque fini !',
    'registerYouth.successText': "Un email vient d'être envoyé à ton parent à l'adresse {email}. Dès qu'il aura donné son autorisation, tu recevras un email pour te connecter.",
    'registerAdult.title': 'Espace adulte',
    'registerAdult.name': 'Votre nom',
    'registerAdult.namePlaceholder': 'ex : Sophie Martin',
    'registerAdult.email': 'Votre email',
    'registerAdult.emailPlaceholder': 'vous@exemple.fr',
    'registerAdult.note': 'Après l\'envoi du formulaire, un code à 6 chiffres vous sera envoyé par email pour confirmer votre adresse — puis votre compte sera actif et connecté.',
    'registerYouth.noteAdult': 'Tu as 18 ans ou plus : ton compte sera activé dès la vérification de ton email, sans autorisation parentale.',
    'registerYouth.noteNeutral': "Indique ton âge : si tu as moins de 18 ans, l'accord d'un parent sera demandé par email ; sinon ton compte sera activé directement.",
    'registerYouth.otpTitle': 'Vérifie ton email',
    'registerAdult.otpTitle': 'Vérifiez votre email',
    'register.otpLabel': 'Code de vérification',
    'register.otpSubmit': 'Valider mon inscription',
    'register.otpBack': 'Modifier mes informations',
    'register.codeLabel': "Code d'invitation (reçu par email)",
    'registerAdult.submit': 'Créer mon compte',
    'registerAdult.creating': 'Création…',
    'registerAdult.created': 'Compte {role} créé ! Connectez-vous.',
    'registerAdult.roleEducateur': 'Éducateur / Encadrant',
    'requestAccess.title': 'Demander mon accès',
    'requestAccess.intro': "L'aventure se rejoint sur invitation (code du livre ou code d'un encadrant). Tu n'en as pas ? Dis-nous qui tu es : nous t'en enverrons un si ta demande est acceptée.",
    'requestAccess.name': 'Ton nom / prénom',
    'requestAccess.namePlaceholder': 'ex : Noah',
    'requestAccess.email': 'Ton email',
    'requestAccess.roleLabel': "Tu rejoins l'aventure en tant que…",
    'requestAccess.roleJeune': 'Lecteur·trice',
    'requestAccess.roleParent': 'Parent',
    'requestAccess.roleEducateur': 'Éducateur / Coach',
    'requestAccess.motivation': 'Ta motivation (facultatif)',
    'requestAccess.motivationPlaceholder': 'ex : je lis le livre avec mon club…',
    'requestAccess.submit': 'Envoyer ma demande',
    'requestAccess.successTitle': 'Demande envoyée !',
    'requestAccess.successText': "Ta demande est envoyée ! Surveille ta boîte mail ({email}) : le lien pour créer ton compte arrive par email.",
    'consent.error': "Ce lien d'autorisation est invalide ou a expiré.",
    'consent.title': 'Autorisation parentale',
    'consent.intro': '{name}{age} souhaite rejoindre l\'aventure On croit qu\'on joue ! aux côtés d\'Eliano.',
    'consent.ageSuffix': ' ({age} ans)',
    'consent.b1': "28 chapitres du livre prolongés par 10 clés d'expérience chacun",
    'consent.b2': 'Un carnet personnel chiffré, lisible uniquement par votre enfant',
    'consent.b3': 'Vous pourrez suivre sa progression depuis votre espace parent',
    'consent.b4': "Conforme RGPD.",
    'consent.approve': "J'autorise",
    'consent.refuse': 'Je refuse',
    'consent.approvedTitle': 'Merci !',
    'consent.approvedText': 'Le compte de {name} est activé. Un email vient de lui être envoyé pour se connecter. Vous pouvez vous aussi vous connecter avec votre email ({email}) pour suivre sa progression.',
    'consent.refusedTitle': "C'est noté",
    'consent.refusedText': 'Le compte ne sera pas activé. Aucune donnée supplémentaire ne sera conservée.',
    'book.eyebrow': 'Le roman',
    'book.subtitle': 'Le prix du rêve sportif',
    'book.p1': "L'histoire d'Eliano, un jeune footballeur qui découvre que le vrai prix d'un rêve n'est pas la victoire, mais ce qu'on devient en le poursuivant. Un roman littéraire et sportif en 28 chapitres, pensé pour les jeunes et leurs familles.",
    'book.p2': "Chaque chapitre se prolonge sur la plateforme par 10 clés de l'Héritage : émotions, sagesse, lettre d'un mentor, dialogue en famille, mission à vivre, Give Back…",
    'book.f1t': '28 chapitres',
    'book.f1d': 'en 4 actes, du premier rêve à la transmission',
    'book.f2t': '10 clés',
    'book.f2d': 'une expérience pédagogique par chapitre',
    'book.f3t': 'En famille',
    'book.f3d': 'des questions pour en parler ensemble',
    'book.f4t': 'Give Back',
    'book.f4d': 'chaque lecteur devient passeur',
    'book.cta': "Rejoindre l'aventure",
    'media.eyebrow': 'Médias',
    'media.title': 'Le projet dans les médias',
    'media.intro': "« On croit qu'on joue ! » est plus qu'un roman : c'est un mouvement éducatif qui unit sport, valeurs et transmission. Retrouvez ici les contenus officiels du projet.",
    'media.f1t': 'Les chansons officielles',
    'media.f1d': "Chaque chapitre a sa chanson officielle, à découvrir dans l'espace jeune.",
    'media.f2t': 'Podcasts & extraits audio',
    'media.f2d': "Des lectures et témoignages pour prolonger l'histoire à voix haute.",
    'media.f3t': 'Vidéos pédagogiques',
    'media.f3d': "Des contenus courts autour des 10 clés de l'Héritage.",
    'media.f4t': 'Dossier de presse',
    'media.f4d': 'Dossier de presse et visuels officiels à télécharger sur la page Presse.',
    'about.eyebrow': 'À propos',
    'about.title': 'Un livre, une plateforme, un mouvement',
    'about.intro': "« On croit qu'on joue ! » est né d'une conviction : les valeurs du sport — courage, écoute, transmission — s'apprennent aussi par les histoires. Le roman raconte l'aventure d'Eliano ; la plateforme la prolonge en expérience vécue, en famille ou au club.",
    'about.v1t': 'Bienveillance',
    'about.v1d': 'Un espace pensé pour les jeunes : ludique, encourageant, sans jugement ni notation.',
    'about.v2t': 'Sécurité',
    'about.v2d': 'Consentement parental obligatoire, carnet chiffré de bout en bout, hébergement UE, conformité RGPD.',
    'about.v3t': 'Transmission',
    'about.v3d': 'La philo Give Back : chaque jeune qui grandit aide un autre à commencer.',
    'about.teamTitle': 'La Team Héritage',
    'about.teamText': "Parents, coachs, éducateurs, jeunes relais : devenez ambassadeur ou ambassadrice du projet. Votre mission : faire découvrir l'aventure d'Eliano autour de vous et aider d'autres jeunes à commencer. Déposez votre candidature :",
    'about.ambName': 'Votre nom',
    'about.ambEmail': 'Votre email',
    'about.ambOrg': 'Club / école / association (facultatif)',
    'about.ambMessage': 'Pourquoi souhaitez-vous rejoindre la Team Héritage ?',
    'about.ambSubmit': 'Candidater à la Team Héritage',
    'about.ambSuccessTitle': 'Candidature envoyée !',
    'about.ambSuccessText': "L'équipe vous répondra par email à {email}.",
    'about.supportTitle': 'Soutenir le projet',
    'about.supportText': "Ce projet est porté par une campagne de financement participatif : chaque soutien aide à faire vivre l'aventure d'Eliano auprès de plus de jeunes.",
    'about.clubTitle': 'Vous êtes un club, une école, une association ?',
    'about.clubText': "Rejoignez les clubs pilotes et ouvrez l'aventure à vos jeunes. Demandez votre accès, nous vous répondrons rapidement.",
    'about.clubCta': 'Demander un accès',
    'masterclass.eyebrow': 'Rendez-vous OCQJ !',
    'masterclass.title': "Rencontres autour de l'aventure d'Eliano",
    'masterclass.intro': 'Des Rendez-vous OCQJ animés avec les mentors du livre : sport, valeurs, transmission. Parents, éducateurs et jeunes sont les bienvenus.',
    'masterclass.full': 'Complet',
    'masterclass.placeOne': '{n} place restante',
    'masterclass.placeMany': '{n} places restantes',
    'masterclass.registered': '{count}/{capacity} inscrits',
    'masterclass.alreadyRegistered': 'Inscrit(e) — à très vite !',
    'masterclass.register': "Je m'inscris",
    'masterclass.loginToRegister': "Connecte-toi pour t'inscrire",
    'masterclass.toastAlready': 'Tu es déjà inscrit(e) !',
    'masterclass.toastConfirmed': 'Inscription confirmée — vérifie tes emails !',
    'masterclass.emptyTitle': 'Aucun rendez-vous programmé pour le moment.',
    'masterclass.emptyText': 'Les prochaines dates seront annoncées ici.',
    'account.title': 'Mon compte',
    'account.subtitle': 'Tes informations et tes droits RGPD.',
    'account.profile': 'Profil',
    'account.name': 'Nom',
    'account.email': 'Email',
    'account.role': 'Rôle',
    'account.age': 'Âge',
    'account.ageValue': '{age} ans',
    'account.exportTitle': "Mes données (droit d'accès)",
    'account.exportText': "Télécharge un fichier JSON contenant toutes tes données : compte, progression, clés de l'Héritage, carnet (déchiffré pour toi seul), inscriptions Rendez-vous OCQJ.",
    'account.exportBtn': 'Exporter mes données',
    'account.exportOk': 'Tes données sont téléchargées !',
    'account.exportError': "Erreur lors de l'export",
    'account.deleteTitle': "Supprimer mon compte (droit à l'effacement)",
    'account.deleteText': 'Suppression définitive : compte, carnet, progression, inscriptions et liens familiaux. Cette action est irréversible.',
    'account.deleteBtn': 'Supprimer définitivement',
    'account.deleteOk': 'Compte et données supprimés. À bientôt peut-être !',
    'account.deleteDialogTitle': 'Supprimer ton compte ?',
    'account.deleteDialogText': 'Toutes tes données (carnet, progression, badges) seront définitivement effacées. Cette action est irréversible.',
    'account.deleteConfirm': 'Oui, tout supprimer',
    'account.deleting': 'Suppression…',
    'account.rgpdNote': 'Conforme RGPD : hébergement UE, carnet chiffré.',
    'youth.eyebrow': 'Mon Espace Héritage',
    'youth.welcome': 'Bienvenue {name}.',
    'youth.question': 'Où en es-tu dans ton aventure ?',
    'youth.progressLabel': '% du parcours pédagogique réalisé',
    'youth.chapterProgress': 'Chapitre {current} / 28',
    'youth.weeklySuggestion': "Cette semaine, Eliano t'invite à travailler : {axis}.",
    'youth.statChapters': 'Chapitres',
    'youth.statExperiences': 'Expériences',
    'youth.statMissions': 'Missions',
    'youth.statCarnet': 'Notes carnet',
    'youth.continue': "Continuer l'aventure",
    'youth.myRadar': "Ma Roue de l'Héritage",
    'youth.myDiary': 'Mon carnet secret',
    'youth.myDiarySub': 'Chiffré — visible par toi seul(e)',
    'youth.myJourney': 'Mon parcours',
    'youth.myJourneySub': 'Synthèse des 28 chapitres',
    'youth.myBadges': 'Mes badges',
    'parent.hello': 'Bonjour {name}',
    'parent.intro': "Suivez la progression de votre enfant dans l'aventure d'Eliano. Son carnet reste chiffré et privé.",
    'parent.years': '{age} ans',
    'parent.consentAt': 'Consentement accordé le {date}',
    'parent.chaptersCount': '{done}/{total} chapitres',
    'parent.progression': 'Chapitres terminés',
    'parent.radar': "Roue de l'Héritage",
    'parent.noChildrenTitle': 'Aucun enfant lié à votre compte pour le moment.',
    'exchange.sectionTitle': "Sujets d'échange & défis",
    'exchange.generalIntro': "Des idées pour discuter et vous lancer des défis — chacun peut challenger l'autre !",
    'exchange.general': 'Sujets généraux',
    'exchange.byChapter': 'Par chapitre (selon sa progression)',
    'exchange.chapterN': 'Chapitre {n}',
    'exchange.challengeLabel': 'Défi mutuel',
    'exchange.launch': 'Lancer ce défi',
    'exchange.launched': 'Défi lancé ! Le jeune le voit dans son espace.',
    'exchange.active': 'Défis lancés',
    'exchange.launchedBadge': 'En cours',
    'exchange.doneBadge': 'Relevé',
    'exchange.markDone': 'Marquer relevé',
    'exchange.reopen': 'Rouvrir',
    'exchange.empty': 'Aucun sujet pour le moment.',
    'youth.challengesTitle': 'Défis lancés pour toi',
    'youth.challengeFrom': '{name} te défie :',
    'youth.challengeStatusDone': 'Relevé !',
    'youth.challengeStatusLaunched': 'À relever',
    'admin.tabTopics': 'Sujets',
    'admin.topicsCount': '{n} sujets d\'échange',
    'admin.topicNew': 'Nouveau sujet',
    'admin.topicChapter': 'Chapitre lié',
    'admin.topicGeneral': 'Général (tous les jeunes)',
    'admin.topicTitle': 'Titre du sujet',
    'admin.topicPrompt': "Question pour susciter l'échange",
    'admin.topicChallenge': 'Défi mutuel proposé',
    'admin.topicSaved': 'Sujet enregistré !',
    'admin.topicDeleted': 'Sujet supprimé',
    'admin.topicDeleteTitle': 'Supprimer ce sujet ?',
    'admin.topicDeleteText': 'Le sujet ne sera plus proposé aux parents et éducateurs.',
    'admin.colChapter': 'Chapitre',
    'admin.colPrompt': 'Question',
    'admin.colChallenge': 'Défi',
    'parent.noChildrenText': "Le lien se crée automatiquement quand vous autorisez l'inscription de votre enfant.",
    'diary.title': 'Mon carnet de jeu',
    'diary.subtitle': 'Chiffré — même les adultes ne peuvent pas le lire.',
    'diary.export': 'Exporter en PDF',
    'diary.new': 'Nouvelle page',
    'diary.titlePlaceholder': 'Titre de ma page…',
    'diary.bodyPlaceholder': 'Raconte ta journée, tes idées, tes rêves…',
    'diary.save': 'Écrire dans le carnet',
    'diary.saved': "C'est écrit dans ton carnet !",
    'diary.deleted': 'Page arrachée !',
    'diary.exported': 'Ton carnet est téléchargé !',
    'diary.reflections': 'Mes réflexions de chapitres',
    'diary.myNotebook': 'Mon carnet',
    'diary.beforeTurning': 'Avant de tourner la page',
    'diary.untitled': 'Sans titre',
    'diary.empty': 'Ton carnet attend ta première histoire…',
    'synthesis.lockedTitle': 'Ton histoire commence bientôt',
    'synthesis.lockedText': 'La synthèse « Ton histoire commence maintenant » se débloque après le chapitre 28.',
    'synthesis.youCompleted': 'Tu as terminé',
    'synthesis.outOf': 'sur {total}.',
    'synthesis.continue': "Continuer l'aventure",
    'synthesis.eyebrow': 'Synthèse des 28 chapitres',
    'synthesis.title': 'Ton histoire commence maintenant',
    'synthesis.subtitle': "Maintenant… c'est à toi.",
    'synthesis.overall': 'Parcours réalisé',
    'synthesis.missions': 'Missions accomplies',
    'synthesis.phrases': 'Mes phrases préférées',
    'synthesis.engagement': 'Mon engagement',
    'synthesis.engagementPrompt': "À mon tour, je m'engage à…",
    'synthesis.engagementPlaceholder': "…aider quelqu'un à commencer, comme Eliano m'a aidé.",
    'synthesis.engagementSave': 'Graver mon engagement',
    'synthesis.engagementSaved': 'Ton engagement est gravé dans ton histoire.',
    'footer.faq': 'FAQ',
    'chapter.notFound': 'Chapitre introuvable',
    'chapter.keyValidated': 'Clé validée : +{value} points',
    'chapter.score': '{score} / 100 — parcours du chapitre',
    'chapter.done': 'Terminé',
    'chapter.intro': "Entre dans l'Espace Héritage : 10 clés t'attendent.",
    'chapter.closingWord': 'Le mot de la fin',
    'chapter.song': 'Chanson officielle : {title}',
    'chapter.authorNote': "Regard d'auteur",
    'chapter.completeBtn': "J'ai terminé ce chapitre !",
    'chapter.completeNext': 'Chapitre terminé ! Le suivant est débloqué.',
    'chapter.completeDone': 'Chapitre terminé, bravo !',
    'keys.coeur.title': "Dans le cœur d'Eliano",
    'keys.sagesse.title': 'Les graines de sagesse',
    'keys.phrase.title': 'La phrase qui reste',
    'keys.mentor.title': 'Le regard du mentor',
    'keys.dialogue.title': 'Parlons-en ensemble',
    'keys.mission.title': "La mission d'Eliano",
    'keys.carnet.title': "Le carnet d'Eliano",
    'keys.giveback.title': 'Give Back',
    'keys.aventure.title': "Continue l'aventure",
    'keys.projection.title': 'Avant de tourner la page',
    'keys.coeur.question': 'Quelles émotions as-tu ressenties, toi aussi ?',
    'keys.coeur.action': "J'ai identifié mes émotions",
    'keys.coeur.toast': 'Tes émotions sont notées !',
    'keys.sagesse.question': 'Touche les graines que tu veux retenir :',
    'keys.sagesse.action': 'Je retiens ces graines',
    'keys.sagesse.toast': 'Graines retenues !',
    'keys.phrase.action': 'Je garde cette phrase',
    'keys.phrase.toast': 'Phrase gardée dans tes favorites !',
    'keys.mentor.letterFrom': 'Une lettre de {name}',
    'keys.mentor.action': "J'ai lu la lettre",
    'keys.mentor.toast': 'Lettre du mentor lue !',
    'keys.dialogue.action': 'Dialogue réalisé (5-15 min)',
    'keys.dialogue.toast': 'Beau dialogue !',
    'keys.mission.started': 'Mission commencée (+5)',
    'keys.mission.startedToast': 'Mission commencée : +5 !',
    'keys.mission.done': 'Mission accomplie (+10)',
    'keys.mission.doneToast': 'Mission accomplie, bravo !',
    'keys.carnet.writes': 'Eliano écrit :',
    'keys.carnet.promptDefault': "Et toi ? Aujourd'hui, j'ai compris que...",
    'keys.carnet.placeholder': "Aujourd'hui, j'ai compris que…",
    'keys.carnet.encrypted': 'Ton écrit est chiffré : toi seul(e) peux le lire.',
    'keys.carnet.action': 'Écrire dans mon carnet',
    'keys.carnet.toast': 'Écrit dans ton carnet secret !',
    'keys.giveback.photoAlt': 'Ma photo Give Back',
    'keys.giveback.changePhoto': 'Changer la photo',
    'keys.giveback.addPhoto': 'Ajouter une photo de mon action',
    'keys.giveback.withoutPhoto': 'Valider sans photo',
    'keys.giveback.photoToast': 'Photo de ton action ajoutée — Give Back validé !',
    'keys.giveback.toast': 'Give Back réalisé — transmission en marche !',
    'keys.giveback.uploadError': "Erreur lors de l'envoi",
    'keys.aventure.action': "J'ai exploré les contenus",
    'keys.aventure.toast': 'Bonne exploration !',
    'keys.projection.placeholder': 'Ta réponse…',
    'keys.projection.action': 'Je suis prêt·e pour la suite',
    'keys.projection.toast': 'Prêt(e) pour la suite !',
    'educator.title': 'Espace encadrant',
    'educator.subtitle': 'Vue agrégée de vos jeunes — bonjour {name}.',
    'educator.groupLabel': 'Groupe :',
    'educator.allYouths': 'Tous les jeunes',
    'educator.newGroup': 'Nouveau groupe',
    'educator.edit': 'Modifier',
    'educator.delete': 'Supprimer',
    'educator.activeYouths': 'Jeunes actifs',
    'educator.avgProgress': 'Progression moyenne',
    'educator.groupRadar': 'Roue moyenne du groupe',
    'educator.perYouth': 'Détail par jeune',
    'educator.emptyAll': 'Aucun jeune dans vos groupes pour le moment — créez un groupe et ajoutez des jeunes par email, ou invitez-les avec vos codes : ils apparaîtront automatiquement dans « Mes jeunes ».',
    'educator.myCode': 'Mon code d\'invitation jeunes',
    'educator.myCodeHelp': 'Partagez ce code : les jeunes qui s\'inscrivent avec apparaissent automatiquement dans votre groupe « Mes jeunes ».',
    'educator.myCodeUses': '{n}/{max} utilisations',
    'educator.generateCode': 'Générer mon code',
    'educator.codeCreated': 'Code généré !',
    'educator.emptyGroup': 'Ce groupe est vide — ajoutez des jeunes avec « Modifier ».',
    'educator.editGroup': 'Modifier le groupe',
    'educator.groupName': 'Nom du groupe',
    'educator.groupNamePlaceholder': 'ex : U12 — FC Valombre',
    'educator.groupEmails': 'Emails des jeunes (un par ligne — comptes actifs uniquement)',
    'educator.groupEmailsNote': 'Les jeunes doivent avoir un compte actif (inscription validée par leur parent).',
    'educator.save': 'Enregistrer',
    'educator.unresolved': '{n} email(s) introuvable(s) ou compte non actif : {list}',
    'educator.saved': 'Groupe enregistré !',
    'educator.deleted': 'Groupe supprimé',
    'educator.detailProgress': "{done}/{total} chapitres complétés — {percent}% des expériences de l'Héritage",
    'educator.diaryPrivate': 'Le carnet personnel du jeune reste chiffré et invisible.',
    'educator.deleteTitle': 'Supprimer ce groupe ?',
    'educator.deleteText': 'Le groupe sera supprimé, mais les comptes des jeunes ne sont pas affectés.',
    'admin.subtitle': "Contenu du livre, codes d'invitation, demandes d'accès, utilisateurs et audit.",
    'admin.tabChapters': 'Chapitres',
    'admin.tabCodes': 'Codes',
    'admin.tabRequests': 'Demandes',
    'admin.tabAmbassadors': 'Ambassadeurs',
    'admin.tabMasterclass': 'Rendez-vous OCQJ !',
    'admin.tabQrcodes': 'QR codes',
    'admin.tabUsers': 'Utilisateurs',
    'admin.tabAudit': 'Audit',
    'admin.chaptersCount': '{n} chapitres',
    'admin.newChapter': 'Nouveau chapitre',
    'admin.colTitle': 'Titre',
    'admin.colAct': 'Acte',
    'admin.colPublished': 'Publié',
    'admin.chapterSaved': 'Chapitre enregistré !',
    'admin.chapterError': 'Erreur (vérifie le JSON chanson/clés)',
    'admin.chapterDeleted': 'Chapitre supprimé',
    'admin.chapterDeleteConfirm': 'Supprimer ce chapitre ?',
    'admin.chapterDeleteText': 'Le chapitre {n} sera définitivement supprimé de la plateforme.',
    'admin.role': 'Rôle',
    'admin.count': 'Nombre',
    'admin.generate': 'Générer',
    'admin.codesGenerated': '{n} code(s) généré(s)',
    'admin.colCode': 'Code',
    'admin.colUses': 'Utilisations',
    'admin.colActive': 'Actif',
    'admin.colName': 'Nom',
    'admin.colEmail': 'Email',
    'admin.colMessage': 'Message',
    'admin.colStatus': 'Statut',
    'admin.colOrganisation': 'Organisation',
    'admin.statusPending': 'En attente',
    'admin.statusApproved': 'Acceptée',
    'admin.statusRejected': 'Refusée',
    'admin.requestsEmpty': "Aucune demande d'accès pour le moment.",
    'admin.approveTitle': 'Accepter et envoyer un code',
    'admin.rejectTitle': 'Refuser',
    'admin.requestDeleteTitle': 'Supprimer',
    'admin.requestDeleteConfirm': 'Supprimer définitivement cette demande ? Cette action est irréversible.',
    'admin.requestDeleted': 'Demande supprimée',
    'admin.codeSent': 'Code {code} envoyé par email',
    'admin.requestRejected': 'Demande refusée',
    'admin.ambassadorsEmpty': 'Aucune candidature pour le moment.',
    'admin.ambassadorApproved': 'Ambassadeur accepté — email de bienvenue envoyé',
    'admin.ambassadorRejected': 'Candidature refusée',
    'admin.ambassadorApproveTitle': 'Accepter (email de bienvenue)',
    'admin.mcCount': '{n} rendez-vous',
    'admin.newMc': 'Nouveau rendez-vous',
    'admin.colDate': 'Date',
    'admin.colLocation': 'Lieu',
    'admin.colRegistrations': 'Inscrits',
    'admin.colActiveF': 'Active',
    'admin.online': 'En ligne',
    'admin.seeRegs': '{count}/{capacity} — voir',
    'admin.mcEmpty': 'Aucun rendez-vous — créez le premier !',
    'admin.mcSaved': 'Rendez-vous enregistré !',
    'admin.mcError': 'Erreur (vérifie la date)',
    'admin.mcDeleted': 'Rendez-vous supprimé',
    'admin.mcEdit': 'Modifier le rendez-vous',
    'admin.mcTitle': 'Titre',
    'admin.mcTitlePlaceholder': 'ex : Le leadership avec Dimitri',
    'admin.mcDescription': 'Description',
    'admin.mcDate': 'Date et heure',
    'admin.mcCapacity': 'Capacité',
    'admin.mcLocation': 'Lieu (vide = en ligne)',
    'admin.mcLocationPlaceholder': 'ex : Stade municipal, Lyon',
    'admin.mcActive': 'Visible et ouverte aux inscriptions',
    'admin.regsTitle': 'Inscrits — {title}',
    'admin.regsEmpty': 'Aucun inscrit pour le moment.',
    'admin.qrInfo': "Chaque QR code renvoie à l'URL propre du chapitre (<domaine>/chapitre/N) — à imprimer dans le livre. Le jeune devra être connecté pour ouvrir le chapitre.",
    'admin.qrChapter': 'Ch. {n}',
    'admin.resendTitle': "Renvoyer l'email de consentement au parent",
    'admin.consentResent': 'Email de consentement renvoyé au parent de {name}',
    'admin.userDeleteTitle': 'Supprimer le compte et ses données (RGPD)',
    'admin.userDeleted': 'Compte supprimé (données effacées)',
    'admin.userDeleteDialogTitle': 'Supprimer ce compte ?',
    'admin.userDeleteDialogText': 'Le compte de {name} ({email}) et toutes ses données (carnet, progression, inscriptions) seront définitivement effacés. Action irréversible (RGPD).',
    'admin.deleteForever': 'Supprimer définitivement',
    'admin.colActor': 'Acteur',
    'admin.colAction': 'Action',
    'admin.colDetails': 'Détails',
    'admin.chapterEdit': 'Modifier le chapitre {n}',
    'admin.chapterNumber': 'Numéro',
    'admin.chapterActPlaceholder': 'Acte I — Le feu des premiers rêves',
    'admin.chapterSubtitle': 'Accroche (sous-titre)',
    'admin.chapterClosing': 'Mot de la fin',
    'admin.chapterAuthor': "Regard d'auteur",
    'admin.chapterSong': 'Chanson officielle (JSON : title, style, lyrics)',
    'admin.chapterKeys': "10 clés de l'Héritage (JSON : coeur, sagesse, phrase, mentor, dialogue, mission, carnet, giveback, aventure, projection)",
    'share.wheel': 'Partager ma Roue',
    'share.title': "Ma Roue de l'Héritage",
    'share.downloaded': 'Image de ta Roue téléchargée !',
    'share.error': 'Partage impossible pour le moment',
    'share.text': "Ma Roue de l'Héritage — {percent}% du parcours réalisé !",
    'faq.eyebrow': 'FAQ & témoignages',
    'faq.title': 'Questions fréquentes',
    'faq.intro': "Tout ce qu'il faut savoir pour rejoindre et vivre l'aventure d'Eliano.",
    'faq.q1': "Comment rejoindre l'aventure ?",
    'faq.a1': "Avec le code présent dans le livre, un code d'invitation d'un encadrant, ou en demandant un accès gratuit depuis la page d'accueil.",
    'faq.q2': 'À partir de quel âge ?',
    'faq.a2': "L'aventure est pensée pour les 8-15 ans, en famille ou au club. Le compte d'un jeune est toujours activé avec l'autorisation d'un parent.",
    'faq.q3': 'Qui peut lire le carnet de mon enfant ?',
    'faq.a3': "Personne d'autre que lui. Le carnet est chiffré : ni les parents, ni les éducateurs, ni l'équipe ne peuvent le lire.",
    'faq.q4': "C'est quoi, la Roue de l'Héritage ?",
    'faq.a4': "Un radar à 10 branches qui grandit avec les expériences vécues (émotions, missions, dialogues…). Ce n'est jamais une note : c'est une carte de progression.",
    'faq.q5': 'Que sont les Give Back ?',
    'faq.a5': 'Des actions de transmission : chaque jeune qui grandit aide un autre à commencer — partager le livre, coacher un cadet, raconter l\'histoire.',
    'faq.q6': 'Mes données sont-elles en sécurité ?',
    'faq.a6': 'Oui : hébergement européen, conformité RGPD, export et suppression de vos données en un clic depuis « Mon compte ».',
    'faq.q7': 'Comment participer à un Rendez-vous OCQJ ?',
    'faq.q8': 'Quand a lieu la campagne de financement Ulule ?',
    'faq.a8': "Du 4 septembre au 7 novembre 2026. Les contreparties incluent le livre, des ressources éducatives, des Rendez-vous OCQJ et des initiatives Give Back. Le bouton « Soutenir le projet » de l'accueil vous y emmène.",
    'faq.q9': "Je n'ai pas encore de code : comment rester informé·e ?",
    'faq.a9': "Remplissez le formulaire « Envie de suivre l'aventure ? » sur la page d'accueil : indiquez votre profil (lecteur, parent, joueur, club, journaliste, partenaire, ambassadeur) et ce qui vous intéresse (le livre, un Rendez-vous OCQJ ou les deux). Vous recevrez les actualités en avant-première.",
    'faq.q10': "Où entrer le code d'invitation de mon livre ?",
    'faq.a10': "Pendant la campagne (jusqu'au 10 novembre 2026), le formulaire de code se trouve sur la page « Le livre ». Ensuite, il revient sur la page d'accueil.",
    'faq.q11': 'Je suis journaliste ou partenaire : où trouver les supports officiels ?',
    'faq.a11': "La page « Presse » propose le dossier de presse et les visuels officiels (flyer, bannière, jaquette, fiche auteur). La page « Médias » propose le dossier de partenariat, le guide parents & jeunes et les cartes réseaux sociaux.",
    'faq.q12': 'Je représente un club de foot : comment rejoindre les bâtisseurs ?',
    'faq.a12': "Sélectionnez le profil « Un club de foot » dans le formulaire d'accueil, téléchargez le dossier de partenariat depuis l'encart « Je cherche des bâtisseurs », puis faites votre demande via « Devenir partenaire ».",
    'faq.a7': 'Les Rendez-vous OCQJ ! sont annoncés sur la page Rendez-vous OCQJ. Créez un compte puis inscrivez-vous en un clic.',
    'faq.testimonialsTitle': "Ils vivent l'aventure",
    'faq.t1Quote': 'Mon fils relit ses missions chaque soir. La plateforme a transformé sa lecture en projet de vie.',
    'faq.t1Author': 'Sophie, maman de Léa (10 ans)',
    'faq.t2Quote': 'Les 10 clés donnent une trame concrète pour parler de valeurs avec mes U12.',
    'faq.t2Author': 'Claire, éducatrice sportive',
    'faq.t3Quote': "J'ai compris que même les champions échouent. Maintenant j'ose.",
    'faq.t3Author': 'Noah, 11 ans',
    'crm.title': 'CRM Prospection',
    'crm.subtitle': 'Base contacts, pipeline et campagnes de publipostage.',
    'crm.tabDashboard': 'Tableau de bord',
    'crm.tabContacts': 'Contacts',
    'crm.tabPipeline': 'Pipeline',
    'crm.tabCampaigns': 'Campagnes',
    'crm.tabTemplates': 'Modèles',
    'crm.kpiContacts': 'Contacts',
    'crm.kpiSent': 'Emails envoyés',
    'crm.kpiEngaged': 'Engagement',
    'crm.kpiRelances': 'À relancer',
    'crm.contactRate': 'Contacts touchés',
    'crm.engagementRate': "Taux d'engagement",
    'crm.funnelTitle': 'Entonnoir du pipeline',
    'crm.byCategory': 'Contacts par catégorie',
    'crm.importBtn': 'Importer le fichier Excel',
    'crm.importDone': '{imported} contacts importés ({duplicates} doublons, {skipped} sans email)',
    'crm.searchPlaceholder': 'Rechercher (nom, organisation, email)…',
    'crm.allCategories': 'Toutes catégories',
    'crm.allStages': 'Toutes étapes',
    'crm.newContact': 'Nouveau contact',
    'crm.detailTitle': 'Fiche contact',
    'crm.notes': 'Notes & historique',
    'crm.notePlaceholder': 'Note interne…',
    'crm.moveTo': 'Déplacer vers',
    'crm.deleteContact': 'Supprimer ce contact ?',
    'crm.deleteContactText': 'Le contact, ses notes et son historique de messages seront définitivement supprimés.',
    'crm.unsubscribedBadge': 'Désinscrit',
    'crm.lastSent': 'Dernier envoi',
    'crm.relancesTitle': 'À relancer',
    'crm.relancesEmpty': 'Aucune relance en attente — tout est à jour.',
    'crm.daysAgo': 'il y a {n} j (relance à J+{d})',
    'crm.newCampaign': 'Nouvelle campagne',
    'crm.campaignName': 'Nom de la campagne',
    'crm.campaignTemplate': 'Modèle',
    'crm.campaignSegment': 'Segment (vide = tous les contacts avec email)',
    'crm.campaignLang': "Langue de l'email",
    'crm.create': 'Créer',
    'crm.generate': 'Générer les messages',
    'crm.generated': '{n} messages générés',
    'crm.launch': "Lancer l'envoi",
    'crm.launchTitle': "Lancer l'envoi de la campagne ?",
    'crm.launchText': '{n} emails seront envoyés par petits lots (environ 40/minute). Cette action est définitive.',
    'crm.cancelCampaign': 'Annuler la campagne',
    'crm.cancelText': 'Les {n} messages en attente seront supprimés.',
    'crm.previewSubject': 'Objet',
    'crm.statusDraft': 'Brouillon',
    'crm.statusGenerated': 'Prête',
    'crm.statusSending': 'Envoi en cours…',
    'crm.statusDone': 'Terminée',
    'crm.statusCancelled': 'Annulée',
    'crm.statusError': 'Erreur',
    'crm.templatesIntro': 'Modèles du kit éditorial — modifiables. Variables : {Prenom}, {Institution}, {Fonction}, {Email}.',
    'crm.editTemplate': 'Modifier le modèle',
    'crm.subjectFr': 'Objet (FR)',
    'crm.bodyFr': 'Corps (FR)',
    'crm.subjectEn': 'Objet (EN)',
    'crm.bodyEn': 'Corps (EN)',
    'crm.relanceDays': 'Relance après (jours)',
    'crm.savedTemplate': 'Modèle enregistré !',
    'crm.saved': 'Enregistré !',
    'crm.deleted': 'Contact supprimé.',
    'crm.deleteCampaign': 'Supprimer la campagne',
    'crm.deleteCampaignText': 'La campagne et ses {n} messages seront définitivement supprimés.',
    'crm.campaignDeleted': 'Campagne supprimée.',
    'footer.contact': 'Contact',
    'crm.dmOpen': 'Message direct',
    'crm.dmTitle': 'Écrire un message direct',
    'crm.dmRecipient': 'Destinataire (email)',
    'crm.dmRecipientHelp': 'Cherchez un utilisateur ou un contact existant, ou saisissez un nouvel email.',
    'crm.dmSubject': 'Objet',
    'crm.dmBody': 'Votre message…',
    'crm.dmLang': 'Langue',
    'crm.dmSend': 'Envoyer',
    'crm.dmSent': "Message mis en file d'envoi — il partira dans quelques minutes !",
    'crm.dmInvalid': 'Email valide, objet et message requis.',
    'contact.eyebrow': 'Parlons-en',
    'contact.title': 'Contactez-nous',
    'contact.intro': 'Une question sur le livre, un Rendez-vous OCQJ à organiser, un partenariat à imaginer ? Écrivez-nous : chaque message est lu avec attention.',
    'contact.directTitle': 'En direct',
    'contact.reply48': 'Dimitri répond personnellement à chaque message, en général sous 48 h.',
    'contact.name': 'Votre nom',
    'contact.phone': 'Votre téléphone',
    'contact.email': 'Votre email',
    'contact.subjectLabel': 'Votre message concerne…',
    'contact.subject.livre': 'Le livre',
    'contact.subject.masterclass': 'Un Rendez-vous OCQJ !',
    'contact.subject.partenariat': 'Un partenariat',
    'contact.subject.presse': 'La presse',
    'contact.subject.autre': 'Autre chose',
    'contact.message': 'Votre message…',
    'contact.submit': 'Envoyer le message',
    'contact.success': 'Message bien reçu !',
    'contact.successSub': 'Merci pour votre confiance — Dimitri vous répondra personnellement très vite.',
    'contact.error': 'Une erreur est survenue — réessayez ou écrivez directement à dimitri.mfoumou@gmail.com.',
    'crm.campaignCreated': 'Campagne créée',
    'crm.launched': 'Envoi lancé — les emails partent par lots.',
    'crm.stage.a_contacter': 'À contacter',
    'crm.stage.envoye': 'Email envoyé',
    'crm.stage.relance': 'Relance faite',
    'crm.stage.discussion': 'En discussion',
    'crm.stage.gagne': 'Partenaire gagné',
    'crm.stage.sans_suite': 'Sans suite',
    'crm.msgPending': 'En attente',
    'crm.msgSending': 'Envoi…',
    'crm.msgSent': 'Envoyé',
    'crm.msgFailed': 'Échec',
    'crm.colContact': 'Contact',
    'crm.colCategory': 'Catégorie',
    'crm.colStage': 'Étape',
    'crm.colEmail': 'Email',
    'crm.page': 'Page {page}/{pages}',
  },
  en: {
    'common.loading': 'Loading…',
    'common.back': 'Back',
    'common.backHome': 'Back to home',
    'common.home': 'Home',
    'common.sending': 'Sending…',
    'common.cancel': 'Cancel',
    'common.error': 'Something went wrong',
    'common.support': 'Support the project',
    'common.chapter': 'chapter',
    'common.chapters': 'chapters',
    'common.chapterN': 'Chapter {n}',
    'nav.chapters': 'My adventure',
    'nav.diary': 'My diary',
    'nav.synthesis': 'My journey',
    'nav.parent': 'My child',
    'nav.educator': 'My group',
    'nav.admin': 'Back-office',
    'nav.crm': 'CRM',
    'footer.book': 'The book',
    'footer.media': 'Media',
    'footer.masterclass': 'Rendez-vous OCQJ !',
    'footer.about': 'About',
    'footer.access': 'Request access',
    'footer.rgpd': "GDPR compliant — kids' diary encrypted.",
    'roles.jeune': 'Young reader',
    'roles.parent': 'Parent',
    'roles.educateur': 'Educator',
    'roles.admin': 'Administrator',
    'axes.coeur': 'Emotions',
    'axes.sagesse': 'Wisdom',
    'axes.phrase': 'Inspiration',
    'axes.mentor': 'Mentoring',
    'axes.dialogue': 'Dialogue',
    'axes.mission': 'Action',
    'axes.carnet': 'Introspection',
    'axes.giveback': 'Passing it on',
    'axes.aventure': 'Openness',
    'axes.projection': 'Projection',
    'badges.premier-pas.label': 'First step',
    'badges.premier-pas.hint': 'Finish chapter 1',
    'badges.je-me-connais.label': 'I know myself',
    'badges.je-me-connais.hint': 'Write 3 reflections in your diary',
    'badges.je-me-releve.label': 'I get back up',
    'badges.je-me-releve.hint': 'Finish chapter 12 — failure is a teacher',
    'badges.esprit-equipe.label': 'Team spirit',
    'badges.esprit-equipe.hint': 'Complete 3 dialogues',
    'badges.mission-accomplie.label': 'Mission accomplished',
    'badges.mission-accomplie.hint': "Complete your first Eliano's mission",
    'badges.je-remercie.label': 'I say thank you',
    'badges.je-remercie.hint': 'Finish chapter 23 — the promise to your parents',
    'badges.je-transmets.label': 'I pass it on',
    'badges.je-transmets.hint': 'Complete your first Give Back',
    'badges.give-back.label': 'Give Back',
    'badges.give-back.hint': 'Complete 3 acts of giving back',
    'badges.leader-positif.label': 'Positive leader',
    'badges.leader-positif.hint': 'Finish chapter 20 — the champion starts here',
    'badges.heritage.label': 'Legacy',
    'badges.heritage.hint': 'Finish all 28 chapters — the relay is yours',
    'landing.login': 'I already have an account',
    'landing.eyebrow': 'The price of a sporting dream — Eliano’s adventure',
    'landing.titleA': 'The adventure goes on ',
    'landing.titleB': 'after the last page.',
    'landing.intro': 'The book tells Eliano’s story. The platform lets you live it: 28 chapters, 10 keys per chapter, your Legacy Wheel and your secret diary.',
    'landing.codeLabel': 'Enter the code from your book or your invitation code',
    'landing.codePlaceholder': 'e.g. OCQJ-XXXX-XXXX',
    'landing.submit': 'Enter the adventure',
    'landing.checking': 'Checking…',
    'landing.codeInvalid': 'Invalid code',
    'landing.qrHint': 'The QR code in your book opens the matching chapter directly.',
    'landing.noCode': 'No code? Request your access →',
    'landing.communityPrefix': 'Already',
    'landing.communitySuffix': 'completed by the community',
    'landing.givebackOne': 'Give Back',
    'landing.givebackMany': 'Give Backs',
    'landing.missionOne': 'mission',
    'landing.missionMany': 'missions',
    'landing.and': 'and',
    'landing.f1t': 'The 10 Keys of Legacy',
    'landing.f1d': 'Emotions, wisdom, mentor, mission, Give Back… every chapter becomes an experience to live.',
    'landing.f2t': 'Your Legacy Wheel',
    'landing.f2d': 'A 10-branch radar that grows with your actions — never a grade, always an adventure.',
    'landing.f3t': 'Eliano’s diary',
    'landing.f3d': 'Read what Eliano writes, then write your own story in your encrypted, private diary.',
    'landing.security': 'A safe space for kids: accounts activated with a parent’s permission. Encrypted diary.',
    'landing.supportCta': 'Support the project on Ulule',
    'landing.hero.title': "ON CROIT QU'ON JOUE !",
    'landing.hero.subtitle': 'The Price of a Sporting Dream',
    'landing.hero.baseline': 'From a personal dream to a collective legacy',
    'landing.hero.quote': '“Can you become a great champion without first becoming a good person?”',
    'landing.acts.title': 'The 4 acts of the book',
    'landing.acts.1.title': 'Act 1: The Dream',
    'landing.acts.1.desc': 'The initial spark — the birth of a calling that transcends everyday life.',
    'landing.acts.2.title': 'Act 2: The Trials',
    'landing.acts.2.desc': 'Learning through adversity: growing and forging character through hardship.',
    'landing.acts.3.title': 'Act 3: The Choices',
    'landing.acts.3.desc': 'Taking the reins of your destiny, building a future guided by your values.',
    'landing.acts.4.title': 'Act 4: The Legacy',
    'landing.acts.4.desc': 'A champion’s true legacy: what he passes on to the next generation.',
    'landing.pillars.title': 'Much more than a novel: an unprecedented experience',
    'landing.pillars.1.title': 'Illustrated novel',
    'landing.pillars.1.desc': '28 immersive chapters at the heart of a journey of self-discovery.',
    'landing.pillars.2.title': 'Educational journey',
    'landing.pillars.2.desc': 'Challenges, questions and reflections to support growth.',
    'landing.pillars.3.title': 'Interactive platform',
    'landing.pillars.3.desc': 'A one-of-a-kind digital platform: reflection keys, dream journal and exclusive resources for young readers, parents and educators.',
    'landing.pillars.4.title': 'Music & audio',
    'landing.pillars.4.desc': "An original soundtrack composed for the book, to listen to while reading — a first in children's fiction.",
    'landing.pillars.5.title': 'Study on the dream',
    'landing.pillars.5.desc': 'A deep analysis of the workings of sporting ambition.',
    'landing.pillars.6.title': 'Rendez-vous OCQJ !',
    'landing.pillars.6.desc': 'Moments of exchange and sharing to grow together.',
    'landing.audio.title': "The book's soundtrack",
    'landing.audio.desc': 'An innovation: the book has its own music. Listen to these two excerpts and dive into the adventure before even turning the first page.',
    'landing.audio.track1': 'Track 1',
    'landing.audio.track2': 'Track 2',
    'landing.audio.soon': 'Coming soon — being finalised.',
    'landing.mc.title': 'Rendez-vous OCQJ ! — 4 online meetups',
    'landing.mc.subtitle': 'To discover, discuss and build together: four open Zoom evenings, one hour each.',
    'landing.mc.ev1.date': 'Monday 7 Sept. 2026 · 8:00–9:00 pm (Paris)',
    'landing.mc.ev1.audience': 'Press & Media',
    'landing.mc.ev1.objective': 'Introduce the project to the media and create the first press relays.',
    'landing.mc.ev1.subject': 'What if football was first and foremost a school of life?',
    'landing.mc.ev2.date': 'Monday 14 Sept. 2026 · 8:00–9:00 pm (Paris)',
    'landing.mc.ev2.audience': 'Partners & Football ecosystem',
    'landing.mc.ev2.objective': 'Bring together the first builders: clubs, institutions, brands and foundations.',
    'landing.mc.ev2.subject': "I'm passing you the ball. It's yours to convert.",
    'landing.mc.ev3.date': 'Monday 21 Sept. 2026 · 8:00–9:00 pm (Paris)',
    'landing.mc.ev3.audience': 'Parents & Educators',
    'landing.mc.ev3.objective': 'Build parent and educator buy-in around the educational dimension.',
    'landing.mc.ev3.subject': "How do you support a young person's dream without losing them in it?",
    'landing.mc.ev4.date': 'Monday 28 Sept. 2026 · 8:00–9:00 pm (Paris)',
    'landing.mc.ev4.audience': 'Youth & Parents',
    'landing.mc.ev4.objective': "Welcome young people and their families into Eliano's world.",
    'landing.mc.ev4.subject': 'What about you — what is your dream?',
    'landing.mc.zoomTitle': 'Zoom connection — same link for all 4 meetups',
    'landing.mc.zoomId': 'Meeting ID: 856 9303 8418 · Passcode: 531726',
    'landing.mc.cta': 'Join the Zoom meeting',
    'landing.action_band.1': 'READ',
    'landing.action_band.2': 'UNDERSTAND',
    'landing.action_band.3': 'ACT',
    'landing.action_band.4': 'PASS ON',
    'landing.masterclass.title': 'OCQJ Rendez-vous',
    'landing.masterclass.subtitle': 'Participative session (60 to 90 min)',
    'landing.masterclass.points.1': 'Dream without losing yourself',
    'landing.masterclass.points.2': 'Learn from failure',
    'landing.masterclass.points.3': 'Build discipline',
    'landing.masterclass.points.4': 'Choose your circle',
    'landing.masterclass.points.5': 'Prepare for life after football',
    'landing.masterclass.points.6': 'Leadership & legacy',
    'landing.crowdfunding.title': 'Ulule campaign',
    'landing.crowdfunding.subtitle': 'September 4 to November 7, 2026',
    'landing.crowdfunding.desc': 'Join the launch of On croit qu’on joue ! and unlock exclusive rewards.',
    'landing.crowdfunding.points.1': 'Books & educational resources',
    'landing.crowdfunding.points.2': 'Rendez-vous OCQJ ! & Give Back initiatives',
    'landing.crowdfunding.points.3': 'Audio, video & engaged community',
    'landing.giveback.title': 'The Give Back',
    'landing.giveback.desc': 'Pass on, share, include. We provide books and resources to the young people who need them most, together with clubs and partners.',
    'landing.batisseurs.title': 'Looking for builders',
    'landing.batisseurs.desc': 'Partners, clubs, educators, parents, companies… join an adventure that matters for the youth.',
    'landing.batisseurs.cta': 'Become a partner',
    'landing.batisseurs.dossier': 'Partnership dossier (PDF)',
    'landing.lead.profile.club': 'A football club',
    'landing.author.name': "Dimitri M'Foumou-Titi",
    'landing.author.role': 'Author',
    'landing.author.quote': '“Together, let’s make football a school of life and a collective legacy!”',
    'landing.closing': 'Supporting this project means helping write the future of our young people.',
    'landing.lead.title': 'Want to follow the adventure?',
    'landing.lead.desc': "Leave your details: you'll be the first to hear about the book, OCQJ Rendez-vous and the launch.",
    'landing.lead.titleM': 'The site is coming very soon!',
    'landing.lead.descM': 'We are putting the finishing touches to the platform. Leave your details: you will be the first to know about the launch, the book and the OCQJ Rendez-vous.',
    'maintenance.badge': 'Under maintenance',
    'maintenance.title': 'We will be right back!',
    'maintenance.subtitle': 'The site is temporarily under maintenance. In the meantime, watch the project video and leave us your email to be notified of the launch.',
    'landing.lead.name': 'Your first and last name',
    'landing.lead.email': 'Your email',
    'landing.lead.profileLabel': 'You are…',
    'landing.lead.profile.lecteur': 'Future reader',
    'landing.lead.profile.parent': 'Parent',
    'landing.lead.profile.journaliste': 'Journalist',
    'landing.lead.profile.joueur': 'Player',
    'landing.lead.profile.partenaire': 'Partner',
    'landing.lead.profile.ambassadeur': 'Ambassador',
    'landing.lead.interestLabel': "What you're interested in",
    'landing.lead.interest.livre': 'The book',
    'landing.lead.interest.masterclass': 'An OCQJ Rendez-vous',
    'landing.lead.interest.les_deux': 'Both',
    'landing.lead.submit': 'Keep me informed',
    'landing.lead.success': 'Thank you! You are part of the adventure — see you soon.',
    'landing.lead.rgpd': 'Your data is only used to keep you informed. One-click unsubscribe, anytime.',
    'landing.lead.error': 'Something went wrong — please try again.',
    'landing.lead.hasCode': 'Already have the book? Enter your code →',
    'landing.lead.backToForm': '← Back to the information form',
    'landing.videoTitle': 'The adventure on video',
    'footer.privacy': 'Privacy',
    'footer.legal': 'Legal notice',
    'footer.press': 'Press',
    'press.eyebrow': 'Media space',
    'press.title': 'Press & official visuals',
    'press.intro': "Find here the official visuals of the “On croit qu'on joue ! — The Price of a Sporting Dream” project, free to use for your articles and publications (credit: Dimitri M'Foumou-Titi).",
    'press.visual1': '“Inspiring Masterclasses” flyer',
    'press.visual2': 'Official project banner',
    'press.visual3': 'Book cover',
    'press.visual4': "Author's portrait",
    'press.download': 'Download',
    'press.ficheAuteur': 'Download the author profile',
    'press.contactTitle': 'Press contact',
    'press.docsTitle': 'Official documents',
    'press.visualsTitle': 'Official visuals',
    'press.doc1': 'Partnership dossier',
    'press.doc2': 'Press kit',
    'press.doc3': 'Parents & young players guide',
    'press.doc4': 'Social media cards',
    'press.aud1': 'Partners',
    'press.aud2': 'Press',
    'press.aud3': 'Parents & youth',
    'press.aud4': 'Social media',
    'media.docsTitle': 'Downloadable documents',
    'legal.eyebrow': 'Legal information',
    'legal.title': 'Legal notice',
    'legal.intro': 'Last updated: June 2026. Legal information relating to the “On croit qu\'on joue ! — The Price of a Sporting Dream” website and platform.',
    'legal.s1Title': '1. Website publisher',
    'legal.s1Body': "Dimitri M'Foumou-Titi, author and publisher of the “On croit qu'on joue !” project (sole proprietor, France).\nSIREN: 991 741 075 — SIRET: 991 741 075 00014 — APE code: 90.03B (other artistic creation).\nRegistered with the French National Business Register (RNE) on 23/09/2025.\nRegistered office: 4 Cité Croix Saint-Simon, 78100 Saint-Germain-en-Laye — France.\nContact: dimitri.mfoumou@gmail.com — +33 6 98 69 75 58.",
    'legal.s2Title': '2. Publication director',
    'legal.s2Body': "Dimitri M'Foumou-Titi.",
    'legal.s3Title': '3. Hosting',
    'legal.s3Body': 'The site is hosted on a containerized cloud infrastructure operated by the deployment platform. Data is preferably hosted within the European Union.',
    'legal.s4Title': '4. Intellectual property',
    'legal.s4Body': 'All content of the site and of the work “On croit qu\'on joue ! — The Price of a Sporting Dream” (texts, illustrations, visual identity, music, videos) is protected by copyright. Any reproduction, representation or distribution, in whole or in part, without prior written authorization is prohibited.',
    'legal.s5Title': '5. Personal data',
    'legal.s5Body': 'The processing of personal data (accounts, progress, encrypted diary, outreach) is described in the Privacy Policy, accessible below and from the footer.',
    'legal.s6Title': '6. External links',
    'legal.s6Body': "The site contains links to third-party services (Ulule, YouTube, LinkedIn). The publisher is not responsible for their content or practices.",
    'legal.s7Title': '7. Applicable law',
    'legal.s7Body': 'This site is governed by French law. In the event of a dispute, and after an attempt at amicable resolution, the French courts shall have exclusive jurisdiction.',
    'privacy.eyebrow': 'GDPR — your data, your rights',
    'privacy.title': 'Privacy Policy',
    'privacy.intro': "Last updated: June 2026. This policy explains what data is processed by the “On croit qu'on joue ! — The Price of a Sporting Dream” platform and what your rights are.",
    'privacy.s1Title': '1. Data controller',
    'privacy.s1Body': "Dimitri M'Foumou-Titi, publisher of the “On croit qu'on joue !” project.\nContact: dimitri.mfoumou@gmail.com — +33 6 98 69 75 58.",
    'privacy.s2Title': '2. Data we process',
    'privacy.s2Body': "User accounts: email address, first name or nickname, role (child, parent, educator, admin).\nEducational progress: validated keys, Legacy Wheel, badges.\nChild's personal diary: encrypted content (AES-256-GCM), unreadable by the team.\n“Give Back” photos: published only with the user's consent.\nOutreach: professional contact details (imported contacts or details left via the homepage form), history of sends and follow-ups.\nTechnical logs: administration audit trail and rate limiting (anti-abuse).",
    'privacy.s3Title': '3. Purposes',
    'privacy.s3Body': "Provide the educational platform and track children's progress.\nVerify parental consent before activating any child account.\nSend requested communications (book, Rendez-vous OCQJ) and outreach campaigns approved by the publisher.\nKeep the service secure and reliable.",
    'privacy.s4Title': '4. Legal bases',
    'privacy.s4Body': "Contract performance: account creation and educational journey.\nConsent: personal diary, Give Back photos, homepage contact form.\nLegitimate interest: professional outreach, security, anonymized usage statistics.",
    'privacy.s5Title': '5. Retention periods',
    'privacy.s5Body': "Account: for the lifetime of the account, then up to 3 years after last activity.\nEncrypted diary: deleted with the account, with no readable copy.\nOutreach: 3 years after the last exchange; unsubscribing takes effect immediately.\nTechnical logs: 12 months maximum.",
    'privacy.s6Title': '6. Processors',
    'privacy.s6Body': "Application hosting and database (MongoDB), transactional email delivery (Resend), secure file storage. We favour processing within the European Union.",
    'privacy.s7Title': '7. Your rights',
    'privacy.s7Body': "You have the rights of access, rectification, erasure, portability, restriction and objection.\nFrom “My account”: JSON export of your data and permanent account deletion.\nOutreach: one-click unsubscribe link in every email.\nBy email: dimitri.mfoumou@gmail.com. You may also contact the CNIL (cnil.fr).",
    'privacy.s8Title': '8. Protecting minors',
    'privacy.s8Body': "A child's account is activated only after verifiable parental consent (signed link sent to the parent, valid for 72 hours).\nThe parent follows their child's progress but never has access to the encrypted personal diary.",
    'privacy.s9Title': '9. Security and cookies',
    'privacy.s9Body': "Sign-in uses a one-time code sent by email: no password is ever stored.\nFiles are served through signed URLs (15-minute validity), with rate limiting and an audit log of administration actions.\nNo third-party cookies or advertising trackers: only local preferences (session, language) are stored in your browser.",
    'book.codeTitle': 'Have the book? Enter your code',
    'book.givebackTitle': 'The Give Back in action',
    'admin.tabSettings': 'Settings',
    'admin.setTitle': 'Site settings',
    'admin.setVideo': 'Homepage video',
    'admin.setVideoHelp': 'YouTube link or .mp4 file — shown next to the homepage form. Leave empty to hide the video.',
    'admin.settingsSaved': 'Settings saved!',
    'admin.setPages': 'Public pages (activation)',
    'admin.setAudio1': 'Audio track 1 (MP3 file)',
    'admin.setAudio2': 'Audio track 2 (MP3 file)',
    'admin.setAudioHelp': 'Paste a local path or an https URL, or upload the MP3 file from your computer with the button (25 MB max). The excerpts appear in the "Much more than a novel" section of the landing page.',
    'admin.audioUpload': 'Upload MP3',
    'admin.audioTitlePh': 'Track title shown on the landing page (e.g. Song of the Pitch)',
    'admin.audioUploaded': 'File uploaded! Click Save to apply it.',
    'admin.audioInvalid': 'Only .mp3 files are accepted',
    'admin.audioTooBig': 'File too large (25 MB max)',
    'admin.mcEventsTitle': 'Rendez-vous OCQJ ! — 4 online meetups (landing)',
    'admin.mcEventsHelp': 'Empty = default text (translated FR/EN/ES). Your input replaces the displayed text. Section visibility follows the "Rendez-vous OCQJ !" switch of the public pages above.',
    'admin.mcEvTitle': 'Meetup #{n}',
    'admin.analyticsTitle': 'Platform analytics',
    'admin.an.users': 'Active accounts',
    'admin.an.pendingConsent': 'Pending consent',
    'admin.an.signups7': 'Signups (7 d)',
    'admin.an.signups30': 'Signups (30 d)',
    'admin.an.chapters': 'Chapters completed',
    'admin.an.keys': 'Keys answered',
    'admin.an.diary': 'Diary entries',
    'admin.an.family': 'Family links',
    'admin.an.consents': 'Pending consents',
    'admin.an.requests': 'Pending access requests',
    'admin.an.crm': 'CRM contacts',
    'admin.an.mc': 'Rendez-vous OCQJ registrations',
    'admin.an.messages': 'Contact messages',
    'admin.an.recent': 'Latest signups',
    'admin.an.empty': 'No recent signups',
    'admin.maintenanceMode': 'Maintenance mode',
    'admin.maintenanceHelp': 'When enabled, the whole public site shows a maintenance screen with the "Want to follow the adventure?" form. You stay logged in as admin.',
    'admin.setContent': 'Editable content (overrides default copy)',
    'admin.contentEmpty': 'Empty = default text',
    'admin.pageToggle.page_livre': '“The book” page',
    'admin.pageToggle.page_medias': '“Media” page',
    'admin.pageToggle.page_masterclass': '“Rendez-vous OCQJ !” page',
    'admin.pageToggle.page_apropos': '“About” page',
    'admin.pageToggle.page_faq': '“FAQ” page',
    'admin.pageToggle.page_presse': '“Press” page',
    'admin.pageToggle.page_contact': '“Contact” page',
    'admin.contentField.content_landing_quote': 'Hero quote (homepage)',
    'admin.contentField.content_landing_closing': 'Closing banner (homepage)',
    'admin.contentField.content_contact_reply48': 'Reply promise (Contact page)',
    'page.disabled': 'This page is temporarily unavailable — come back soon!',
    'login.title': 'Log in',
    'login.email': 'Your email',
    'login.emailPlaceholder': 'you@example.com',
    'login.noPassword': 'No password: we email you a 6-digit code.',
    'login.requestCode': 'Send me my code',
    'login.codeSent': 'A code has just been sent!',
    'login.sendError': 'Could not send the code',
    'login.codeSentTo': 'A 6-digit code was sent to {email} (valid for 10 minutes).',
    'login.devMode': 'Demo mode — code: {code}',
    'login.submit': 'Log me in',
    'login.invalidCode': 'Invalid code',
    'login.changeEmail': 'Change email',
    'login.noAccount': 'No active account for this email. If your access request was approved, click "Create my account" in the email you received — the account only exists once that sign-up is completed.',
    'login.noAccountCta': 'Request access',
    'login.pendingConsent': 'Your account is still waiting for a parent\'s approval: they need to click the link sent by email to activate it.',
    'ambProfile.title': 'Your ambassador profile',
    'ambProfile.intro': 'Welcome to the Heritage Team! Add your photo and social links: they will be reviewed by our team.',
    'ambProfile.photoLabel': 'Your photo',
    'ambProfile.photoChoose': 'Choose a photo',
    'ambProfile.photoHelp': 'JPG, PNG or WebP — 5 MB max.',
    'ambProfile.photoUpload': 'Upload photo',
    'ambProfile.photoUploaded': 'Photo uploaded!',
    'ambProfile.photoInvalid': 'Accepted formats: JPG, PNG or WebP',
    'ambProfile.photoTooBig': 'Photo too heavy (5 MB max)',
    'ambProfile.linksTitle': 'Your social networks (optional)',
    'ambProfile.linksHelp': '2 links are suggested, you can add up to 5.',
    'ambProfile.url': 'Link (https://…)',
    'ambProfile.addLink': 'Add a link',
    'ambProfile.save': 'Save my links',
    'ambProfile.saved': 'Profile saved!',
    'ambProfile.pendingReview': 'Profile sent: it will be reviewed by our team.',
    'ambProfile.approved': 'Your profile has been approved by our team!',
    'ambProfile.rejected': 'Your profile was rejected by our team: you can edit it and send it again.',
    'ambProfile.notFound': 'Invalid or expired link. Contact us if you think this is a mistake.',
    'ambProfile.networks.instagram': 'Instagram',
    'ambProfile.networks.tiktok': 'TikTok',
    'ambProfile.networks.linkedin': 'LinkedIn',
    'ambProfile.networks.youtube': 'YouTube',
    'ambProfile.networks.other': 'Other',
    'admin.ambassadorProfileTitle': 'View profile (photo + socials)',
    'admin.profileReviewTitle': 'Ambassador profile',
    'admin.approveProfile': 'Approve profile',
    'admin.rejectProfile': 'Reject profile',
    'admin.profileApproved': 'Profile approved',
    'admin.profileRejected': 'Profile rejected',
    'admin.noProfileYet': 'No photo or link yet.',
    'admin.onLanding': 'Profile approved',
    'admin.accessJeuneAuto': 'Automatic approval of "Reader" access requests',
    'admin.accessJeuneAutoHelp': 'ON: the "Create my account" link is sent immediately. OFF: the request waits for your manual approval. Parent and Educator requests are always automatic.',
    'admin.autoBadge': 'Auto',
    'landing.amb.eyebrow': 'Heritage Team',
    'landing.amb.title': 'Our ambassadors',
    'landing.amb.subtitle': 'They share Eliano\'s adventure around them.',
    'side.upcomingTitle': 'Upcoming Rendez-vous',
    'side.upcomingEmpty': 'No upcoming Rendez-vous yet.',
    'side.allEvents': 'See all Rendez-vous',
    'side.newsTitle': 'Video news',
    'side.newsText': 'Messages and news from the team to the whole network.',
    'admin.setNetworkVideo': 'Network news video (YouTube URL — shown in logged-in areas)',
    'registerYouth.title': 'Join Eliano’s adventure',
    'registerYouth.name': 'Your first name',
    'registerYouth.namePlaceholder': 'e.g. Lea',
    'registerYouth.age': 'Your age',
    'registerYouth.agePlaceholder': 'e.g. 10',
    'registerYouth.parentEmail': 'Your parent’s email',
    'registerYouth.parentEmailPlaceholder': 'parent@example.com',
    'registerYouth.note': 'Your parent will receive an email to approve your account. Your personal diary will stay secret, even from them.',
    'registerYouth.submit': 'Ask for permission',
    'registerYouth.successTitle': 'Almost done!',
    'registerYouth.successText': 'An email has just been sent to your parent at {email}. As soon as they approve, you will receive an email to log in.',
    'registerAdult.title': 'Adult area',
    'registerAdult.name': 'Your name',
    'registerAdult.namePlaceholder': 'e.g. Sophie Martin',
    'registerAdult.email': 'Your email',
    'registerAdult.emailPlaceholder': 'you@example.com',
    'registerAdult.note': 'After submitting the form, a 6-digit code will be emailed to you to confirm your address — your account will then be active and logged in.',
    'registerYouth.noteAdult': 'You are 18 or over: your account will be activated as soon as your email is verified, no parental approval needed.',
    'registerYouth.noteNeutral': "Enter your age: if you are under 18, a parent's approval will be requested by email; otherwise your account will be activated directly.",
    'registerYouth.otpTitle': 'Check your email',
    'registerAdult.otpTitle': 'Check your email',
    'register.otpLabel': 'Verification code',
    'register.otpSubmit': 'Confirm my registration',
    'register.otpBack': 'Edit my details',
    'register.codeLabel': 'Invitation code (received by email)',
    'registerAdult.submit': 'Create my account',
    'registerAdult.creating': 'Creating…',
    'registerAdult.created': '{role} account created! You can log in now.',
    'registerAdult.roleEducateur': 'Educator / Coach',
    'requestAccess.title': 'Request my access',
    'requestAccess.intro': 'The adventure is invitation-only (book code or mentor code). Don’t have one? Tell us who you are: we’ll send you one if your request is accepted.',
    'requestAccess.name': 'Your name',
    'requestAccess.namePlaceholder': 'e.g. Noah',
    'requestAccess.email': 'Your email',
    'requestAccess.roleLabel': 'You join the adventure as…',
    'requestAccess.roleJeune': 'Reader',
    'requestAccess.roleParent': 'Parent',
    'requestAccess.roleEducateur': 'Educator / Coach',
    'requestAccess.motivation': 'Your motivation (optional)',
    'requestAccess.motivationPlaceholder': 'e.g. I’m reading the book with my club…',
    'requestAccess.submit': 'Send my request',
    'requestAccess.successTitle': 'Request sent!',
    'requestAccess.successText': 'Your request is sent! Watch your inbox ({email}): the link to create your account arrives by email.',
    'consent.error': 'This authorisation link is invalid or has expired.',
    'consent.title': 'Parental authorisation',
    'consent.intro': '{name}{age} would like to join the On croit qu’on joue ! adventure alongside Eliano.',
    'consent.ageSuffix': ' ({age} years old)',
    'consent.b1': '28 book chapters extended by 10 experience keys each',
    'consent.b2': 'An encrypted personal diary, readable only by your child',
    'consent.b3': 'You can follow their progress from your parent area',
    'consent.b4': 'GDPR compliant.',
    'consent.approve': 'I authorise',
    'consent.refuse': 'I refuse',
    'consent.approvedTitle': 'Thank you!',
    'consent.approvedText': '{name}’s account is now active. A login email has just been sent to them. You can also log in with your email ({email}) to follow their progress.',
    'consent.refusedTitle': 'Noted',
    'consent.refusedText': 'The account will not be activated. No additional data will be kept.',
    'book.eyebrow': 'The novel',
    'book.subtitle': 'The price of a sporting dream',
    'book.p1': 'The story of Eliano, a young footballer who discovers that the true price of a dream is not victory, but who you become while chasing it. A literary and sports novel in 28 chapters, made for kids and their families.',
    'book.p2': 'Each chapter continues on the platform with 10 Keys of Legacy: emotions, wisdom, a mentor’s letter, family dialogue, a mission to live, Give Back…',
    'book.f1t': '28 chapters',
    'book.f1d': 'in 4 acts, from the first dream to passing it on',
    'book.f2t': '10 keys',
    'book.f2d': 'one educational experience per chapter',
    'book.f3t': 'As a family',
    'book.f3d': 'questions to talk about together',
    'book.f4t': 'Give Back',
    'book.f4d': 'every reader becomes a passer-on',
    'book.cta': 'Join the adventure',
    'media.eyebrow': 'Media',
    'media.title': 'The project in the media',
    'media.intro': '“On croit qu’on joue !” is more than a novel: it’s an educational movement bringing together sport, values and transmission. Find the project’s official content here.',
    'media.f1t': 'The official songs',
    'media.f1d': 'Every chapter has its official song, to discover in the kids’ area.',
    'media.f2t': 'Podcasts & audio excerpts',
    'media.f2d': 'Readings and testimonies to keep the story going out loud.',
    'media.f3t': 'Educational videos',
    'media.f3d': 'Short content around the 10 Keys of Legacy.',
    'media.f4t': 'Press kit',
    'media.f4d': 'Press kit and official visuals available for download on the Press page.',
    'about.eyebrow': 'About',
    'about.title': 'A book, a platform, a movement',
    'about.intro': '“On croit qu’on joue !” was born from a conviction: the values of sport — courage, listening, transmission — can also be learned through stories. The novel tells Eliano’s adventure; the platform turns it into a lived experience, with family or at the club.',
    'about.v1t': 'Kindness',
    'about.v1d': 'A space designed for kids: playful, encouraging, with no judgement and no grades.',
    'about.v2t': 'Safety',
    'about.v2d': 'Mandatory parental consent, end-to-end encrypted diary, EU hosting, GDPR compliant.',
    'about.v3t': 'Transmission',
    'about.v3d': 'The Give Back philosophy: every kid who grows helps another one start.',
    'about.teamTitle': 'The Legacy Team',
    'about.teamText': 'Parents, coaches, educators, young ambassadors: become a project ambassador. Your mission: share Eliano’s adventure around you and help other kids get started. Apply now:',
    'about.ambName': 'Your name',
    'about.ambEmail': 'Your email',
    'about.ambOrg': 'Club / school / association (optional)',
    'about.ambMessage': 'Why would you like to join the Legacy Team?',
    'about.ambSubmit': 'Apply to the Legacy Team',
    'about.ambSuccessTitle': 'Application sent!',
    'about.ambSuccessText': 'The team will reply by email to {email}.',
    'about.supportTitle': 'Support the project',
    'about.supportText': 'This project is powered by a crowdfunding campaign: every contribution helps bring Eliano’s adventure to more young people.',
    'about.clubTitle': 'Are you a club, a school, an association?',
    'about.clubText': 'Join the pilot clubs and open the adventure to your kids. Request your access, we’ll reply quickly.',
    'about.clubCta': 'Request access',
    'masterclass.eyebrow': 'Rendez-vous OCQJ !',
    'masterclass.title': 'Meet-ups around Eliano’s adventure',
    'masterclass.intro': 'Rendez-vous OCQJ hosted with the book’s mentors: sport, values, transmission. Parents, educators and kids are all welcome.',
    'masterclass.full': 'Full',
    'masterclass.placeOne': '{n} seat left',
    'masterclass.placeMany': '{n} seats left',
    'masterclass.registered': '{count}/{capacity} registered',
    'masterclass.alreadyRegistered': 'Registered — see you soon!',
    'masterclass.register': 'Sign me up',
    'masterclass.loginToRegister': 'Log in to register',
    'masterclass.toastAlready': 'You are already registered!',
    'masterclass.toastConfirmed': 'Registration confirmed — check your emails!',
    'masterclass.emptyTitle': 'No rendez-vous scheduled yet.',
    'masterclass.emptyText': 'Upcoming dates will be announced here.',
    'account.title': 'My account',
    'account.subtitle': 'Your information and your GDPR rights.',
    'account.profile': 'Profile',
    'account.name': 'Name',
    'account.email': 'Email',
    'account.role': 'Role',
    'account.age': 'Age',
    'account.ageValue': '{age} years old',
    'account.exportTitle': 'My data (right of access)',
    'account.exportText': 'Download a JSON file with all your data: account, progress, Legacy keys, diary (decrypted for you only), Rendez-vous OCQJ registrations.',
    'account.exportBtn': 'Export my data',
    'account.exportOk': 'Your data has been downloaded!',
    'account.exportError': 'Export error',
    'account.deleteTitle': 'Delete my account (right to erasure)',
    'account.deleteText': 'Permanent deletion: account, diary, progress, registrations and family links. This action cannot be undone.',
    'account.deleteBtn': 'Delete permanently',
    'account.deleteOk': 'Account and data deleted. Maybe see you soon!',
    'account.deleteDialogTitle': 'Delete your account?',
    'account.deleteDialogText': 'All your data (diary, progress, badges) will be permanently erased. This action cannot be undone.',
    'account.deleteConfirm': 'Yes, delete everything',
    'account.deleting': 'Deleting…',
    'account.rgpdNote': 'GDPR compliant: EU hosting, encrypted diary.',
    'youth.eyebrow': 'My Legacy Space',
    'youth.welcome': 'Welcome {name}.',
    'youth.question': 'Where are you in your adventure?',
    'youth.progressLabel': '% of the learning journey completed',
    'youth.chapterProgress': 'Chapter {current} / 28',
    'youth.weeklySuggestion': 'This week, Eliano invites you to work on: {axis}.',
    'youth.statChapters': 'Chapters',
    'youth.statExperiences': 'Experiences',
    'youth.statMissions': 'Missions',
    'youth.statCarnet': 'Diary notes',
    'youth.continue': 'Continue the adventure',
    'youth.myRadar': 'My Legacy Wheel',
    'youth.myDiary': 'My secret diary',
    'youth.myDiarySub': 'Encrypted — visible to you only',
    'youth.myJourney': 'My journey',
    'youth.myJourneySub': 'Summary of the 28 chapters',
    'youth.myBadges': 'My badges',
    'parent.hello': 'Hello {name}',
    'parent.intro': 'Follow your child’s progress through Eliano’s adventure. Their diary stays encrypted and private.',
    'parent.years': '{age} years old',
    'parent.consentAt': 'Consent given on {date}',
    'parent.chaptersCount': '{done}/{total} chapters',
    'parent.progression': 'Chapters completed',
    'parent.radar': 'Legacy Wheel',
    'parent.noChildrenTitle': 'No child linked to your account yet.',
    'exchange.sectionTitle': 'Discussion topics & challenges',
    'exchange.generalIntro': 'Ideas to talk and challenge each other — adult and youth can challenge one another!',
    'exchange.general': 'General topics',
    'exchange.byChapter': 'By chapter (based on progress)',
    'exchange.chapterN': 'Chapter {n}',
    'exchange.challengeLabel': 'Mutual challenge',
    'exchange.launch': 'Launch this challenge',
    'exchange.launched': 'Challenge launched! The youth sees it in their space.',
    'exchange.active': 'Launched challenges',
    'exchange.launchedBadge': 'Ongoing',
    'exchange.doneBadge': 'Completed',
    'exchange.markDone': 'Mark as completed',
    'exchange.reopen': 'Reopen',
    'exchange.empty': 'No topics yet.',
    'youth.challengesTitle': 'Challenges for you',
    'youth.challengeFrom': '{name} challenges you:',
    'youth.challengeStatusDone': 'Completed!',
    'youth.challengeStatusLaunched': 'Take it on',
    'admin.tabTopics': 'Topics',
    'admin.topicsCount': '{n} discussion topics',
    'admin.topicNew': 'New topic',
    'admin.topicChapter': 'Linked chapter',
    'admin.topicGeneral': 'General (all youths)',
    'admin.topicTitle': 'Topic title',
    'admin.topicPrompt': 'Question to spark discussion',
    'admin.topicChallenge': 'Suggested mutual challenge',
    'admin.topicSaved': 'Topic saved!',
    'admin.topicDeleted': 'Topic deleted',
    'admin.topicDeleteTitle': 'Delete this topic?',
    'admin.topicDeleteText': 'The topic will no longer be shown to parents and educators.',
    'admin.colChapter': 'Chapter',
    'admin.colPrompt': 'Question',
    'admin.colChallenge': 'Challenge',
    'parent.noChildrenText': 'The link is created automatically when you approve your child’s signup.',
    'diary.title': 'My game diary',
    'diary.subtitle': 'Encrypted — even adults can’t read it.',
    'diary.export': 'Export as PDF',
    'diary.new': 'New page',
    'diary.titlePlaceholder': 'Title of my page…',
    'diary.bodyPlaceholder': 'Tell your day, your ideas, your dreams…',
    'diary.save': 'Write in the diary',
    'diary.saved': 'It’s written in your diary!',
    'diary.deleted': 'Page torn out!',
    'diary.exported': 'Your diary has been downloaded!',
    'diary.reflections': 'My chapter reflections',
    'diary.myNotebook': 'My diary',
    'diary.beforeTurning': 'Before turning the page',
    'diary.untitled': 'Untitled',
    'diary.empty': 'Your diary is waiting for your first story…',
    'synthesis.lockedTitle': 'Your story starts soon',
    'synthesis.lockedText': 'The “Your story starts now” summary unlocks after chapter 28.',
    'synthesis.youCompleted': 'You have finished',
    'synthesis.outOf': 'out of {total}.',
    'synthesis.continue': 'Continue the adventure',
    'synthesis.eyebrow': 'Summary of the 28 chapters',
    'synthesis.title': 'Your story starts now',
    'synthesis.subtitle': 'Now… it’s up to you.',
    'synthesis.overall': 'Journey completed',
    'synthesis.missions': 'Missions accomplished',
    'synthesis.phrases': 'My favourite quotes',
    'synthesis.engagement': 'My commitment',
    'synthesis.engagementPrompt': 'My turn, I commit to…',
    'synthesis.engagementPlaceholder': '…helping someone get started, like Eliano helped me.',
    'synthesis.engagementSave': 'Engrave my commitment',
    'synthesis.engagementSaved': 'Your commitment is engraved in your story.',
    'footer.faq': 'FAQ',
    'chapter.notFound': 'Chapter not found',
    'chapter.keyValidated': 'Key validated: +{value} points',
    'chapter.score': '{score} / 100 — chapter journey',
    'chapter.done': 'Completed',
    'chapter.intro': 'Enter the Legacy Space: 10 keys are waiting for you.',
    'chapter.closingWord': 'The final word',
    'chapter.song': 'Official song: {title}',
    'chapter.authorNote': "Author's note",
    'chapter.completeBtn': 'I finished this chapter!',
    'chapter.completeNext': 'Chapter complete! The next one is unlocked.',
    'chapter.completeDone': 'Chapter complete, well done!',
    'keys.coeur.title': "In Eliano's heart",
    'keys.sagesse.title': 'Seeds of wisdom',
    'keys.phrase.title': 'The quote that stays',
    'keys.mentor.title': "The mentor's gaze",
    'keys.dialogue.title': "Let's talk about it",
    'keys.mission.title': "Eliano's mission",
    'keys.carnet.title': "Eliano's diary",
    'keys.giveback.title': 'Give Back',
    'keys.aventure.title': 'Keep the adventure going',
    'keys.projection.title': 'Before turning the page',
    'keys.coeur.question': 'Which emotions did you feel too?',
    'keys.coeur.action': 'I identified my emotions',
    'keys.coeur.toast': 'Your emotions are noted!',
    'keys.sagesse.question': 'Tap the seeds you want to keep:',
    'keys.sagesse.action': 'I keep these seeds',
    'keys.sagesse.toast': 'Seeds kept!',
    'keys.phrase.action': 'I keep this quote',
    'keys.phrase.toast': 'Quote saved to your favourites!',
    'keys.mentor.letterFrom': 'A letter from {name}',
    'keys.mentor.action': 'I read the letter',
    'keys.mentor.toast': "Mentor's letter read!",
    'keys.dialogue.action': 'Dialogue done (5-15 min)',
    'keys.dialogue.toast': 'Great dialogue!',
    'keys.mission.started': 'Mission started (+5)',
    'keys.mission.startedToast': 'Mission started: +5!',
    'keys.mission.done': 'Mission accomplished (+10)',
    'keys.mission.doneToast': 'Mission accomplished, well done!',
    'keys.carnet.writes': 'Eliano writes:',
    'keys.carnet.promptDefault': 'And you? Today, I understood that...',
    'keys.carnet.placeholder': 'Today, I understood that…',
    'keys.carnet.encrypted': 'Your writing is encrypted: only you can read it.',
    'keys.carnet.action': 'Write in my diary',
    'keys.carnet.toast': 'Written in your secret diary!',
    'keys.giveback.photoAlt': 'My Give Back photo',
    'keys.giveback.changePhoto': 'Change the photo',
    'keys.giveback.addPhoto': 'Add a photo of my action',
    'keys.giveback.withoutPhoto': 'Validate without a photo',
    'keys.giveback.photoToast': 'Photo of your action added — Give Back validated!',
    'keys.giveback.toast': 'Give Back done — passing it on!',
    'keys.giveback.uploadError': 'Upload error',
    'keys.aventure.action': 'I explored the content',
    'keys.aventure.toast': 'Happy exploring!',
    'keys.projection.placeholder': 'Your answer…',
    'keys.projection.action': "I'm ready for what's next",
    'keys.projection.toast': 'Ready for what comes next!',
    'educator.title': 'Mentor area',
    'educator.subtitle': 'Aggregated view of your youths — hello {name}.',
    'educator.groupLabel': 'Group:',
    'educator.allYouths': 'All youths',
    'educator.newGroup': 'New group',
    'educator.edit': 'Edit',
    'educator.delete': 'Delete',
    'educator.activeYouths': 'Active youths',
    'educator.avgProgress': 'Average progress',
    'educator.groupRadar': 'Group average wheel',
    'educator.perYouth': 'Per-youth detail',
    'educator.emptyAll': 'No youths in your groups yet — create a group and add youths by email, or invite them with your codes: they will automatically appear in "My youths".',
    'educator.myCode': 'My youth invitation code',
    'educator.myCodeHelp': 'Share this code: youths who sign up with it automatically appear in your "My youths" group.',
    'educator.myCodeUses': '{n}/{max} uses',
    'educator.generateCode': 'Generate my code',
    'educator.codeCreated': 'Code generated!',
    'educator.emptyGroup': 'This group is empty — add youths with "Edit".',
    'educator.editGroup': 'Edit group',
    'educator.groupName': 'Group name',
    'educator.groupNamePlaceholder': 'e.g. U12 — FC Valombre',
    'educator.groupEmails': 'Youth emails (one per line — active accounts only)',
    'educator.groupEmailsNote': 'Youths must have an active account (signup approved by their parent).',
    'educator.save': 'Save',
    'educator.unresolved': '{n} email(s) not found or account not active: {list}',
    'educator.saved': 'Group saved!',
    'educator.deleted': 'Group deleted',
    'educator.detailProgress': '{done}/{total} chapters completed — {percent}% of Legacy experiences',
    'educator.diaryPrivate': "The youth's personal diary stays encrypted and invisible.",
    'educator.deleteTitle': 'Delete this group?',
    'educator.deleteText': 'The group will be deleted, but youth accounts are not affected.',
    'admin.subtitle': 'Book content, invitation codes, access requests, users and audit.',
    'admin.tabChapters': 'Chapters',
    'admin.tabCodes': 'Codes',
    'admin.tabRequests': 'Requests',
    'admin.tabAmbassadors': 'Ambassadors',
    'admin.tabMasterclass': 'Rendez-vous OCQJ !',
    'admin.tabQrcodes': 'QR codes',
    'admin.tabUsers': 'Users',
    'admin.tabAudit': 'Audit',
    'admin.chaptersCount': '{n} chapters',
    'admin.newChapter': 'New chapter',
    'admin.colTitle': 'Title',
    'admin.colAct': 'Act',
    'admin.colPublished': 'Published',
    'admin.chapterSaved': 'Chapter saved!',
    'admin.chapterError': 'Error (check the song/keys JSON)',
    'admin.chapterDeleted': 'Chapter deleted',
    'admin.chapterDeleteConfirm': 'Delete this chapter?',
    'admin.chapterDeleteText': 'Chapter {n} will be permanently removed from the platform.',
    'admin.role': 'Role',
    'admin.count': 'Count',
    'admin.generate': 'Generate',
    'admin.codesGenerated': '{n} code(s) generated',
    'admin.colCode': 'Code',
    'admin.colUses': 'Uses',
    'admin.colActive': 'Active',
    'admin.colName': 'Name',
    'admin.colEmail': 'Email',
    'admin.colMessage': 'Message',
    'admin.colStatus': 'Status',
    'admin.colOrganisation': 'Organisation',
    'admin.statusPending': 'Pending',
    'admin.statusApproved': 'Approved',
    'admin.statusRejected': 'Rejected',
    'admin.requestsEmpty': 'No access requests yet.',
    'admin.approveTitle': 'Approve and send a code',
    'admin.rejectTitle': 'Reject',
    'admin.requestDeleteTitle': 'Delete',
    'admin.requestDeleteConfirm': 'Permanently delete this request? This action cannot be undone.',
    'admin.requestDeleted': 'Request deleted',
    'admin.codeSent': 'Code {code} sent by email',
    'admin.requestRejected': 'Request rejected',
    'admin.ambassadorsEmpty': 'No applications yet.',
    'admin.ambassadorApproved': 'Ambassador approved — welcome email sent',
    'admin.ambassadorRejected': 'Application rejected',
    'admin.ambassadorApproveTitle': 'Approve (welcome email)',
    'admin.mcCount': '{n} rendez-vous',
    'admin.newMc': 'New rendez-vous',
    'admin.colDate': 'Date',
    'admin.colLocation': 'Location',
    'admin.colRegistrations': 'Registered',
    'admin.colActiveF': 'Active',
    'admin.online': 'Online',
    'admin.seeRegs': '{count}/{capacity} — view',
    'admin.mcEmpty': 'No rendez-vous — create the first one!',
    'admin.mcSaved': 'Rendez-vous saved!',
    'admin.mcError': 'Error (check the date)',
    'admin.mcDeleted': 'Rendez-vous deleted',
    'admin.mcEdit': 'Edit rendez-vous',
    'admin.mcTitle': 'Title',
    'admin.mcTitlePlaceholder': 'e.g. Leadership with Dimitri',
    'admin.mcDescription': 'Description',
    'admin.mcDate': 'Date and time',
    'admin.mcCapacity': 'Capacity',
    'admin.mcLocation': 'Location (empty = online)',
    'admin.mcLocationPlaceholder': 'e.g. City stadium, Lyon',
    'admin.mcActive': 'Visible and open for registration',
    'admin.regsTitle': 'Registrations — {title}',
    'admin.regsEmpty': 'No registrations yet.',
    'admin.qrInfo': 'Each QR code points to the chapter’s clean URL (<domain>/chapitre/N) — to be printed in the book. The youth must be logged in to open the chapter.',
    'admin.qrChapter': 'Ch. {n}',
    'admin.resendTitle': 'Resend the consent email to the parent',
    'admin.consentResent': 'Consent email resent to {name}’s parent',
    'admin.userDeleteTitle': 'Delete the account and its data (GDPR)',
    'admin.userDeleted': 'Account deleted (data erased)',
    'admin.userDeleteDialogTitle': 'Delete this account?',
    'admin.userDeleteDialogText': 'The account of {name} ({email}) and all its data (diary, progress, registrations) will be permanently erased. Irreversible action (GDPR).',
    'admin.deleteForever': 'Delete permanently',
    'admin.colActor': 'Actor',
    'admin.colAction': 'Action',
    'admin.colDetails': 'Details',
    'admin.chapterEdit': 'Edit chapter {n}',
    'admin.chapterNumber': 'Number',
    'admin.chapterActPlaceholder': 'Act I — The fire of first dreams',
    'admin.chapterSubtitle': 'Tagline (subtitle)',
    'admin.chapterClosing': 'Final word',
    'admin.chapterAuthor': "Author's note",
    'admin.chapterSong': 'Official song (JSON: title, style, lyrics)',
    'admin.chapterKeys': '10 Legacy keys (JSON: coeur, sagesse, phrase, mentor, dialogue, mission, carnet, giveback, aventure, projection)',
    'share.wheel': 'Share my Wheel',
    'share.title': 'My Legacy Wheel',
    'share.downloaded': 'Your Wheel image has been downloaded!',
    'share.error': 'Sharing is unavailable right now',
    'share.text': 'My Legacy Wheel — {percent}% of the journey completed!',
    'faq.eyebrow': 'FAQ & testimonials',
    'faq.title': 'Frequently asked questions',
    'faq.intro': 'Everything you need to know to join and live Eliano’s adventure.',
    'faq.q1': 'How do I join the adventure?',
    'faq.a1': 'With the code from the book, an invitation code from a mentor, or by requesting free access from the home page.',
    'faq.q2': 'From what age?',
    'faq.a2': 'The adventure is designed for 8-15 year olds, with family or at the club. A youth account is always activated with a parent’s permission.',
    'faq.q3': 'Who can read my child’s diary?',
    'faq.a3': 'No one but them. The diary is encrypted: neither parents, nor educators, nor the team can read it.',
    'faq.q4': 'What is the Legacy Wheel?',
    'faq.a4': 'A 10-branch radar that grows with lived experiences (emotions, missions, dialogues…). It is never a grade: it is a progress map.',
    'faq.q5': 'What are Give Backs?',
    'faq.a5': 'Acts of passing it on: every kid who grows helps another one start — sharing the book, coaching a younger player, telling the story.',
    'faq.q6': 'Is my data safe?',
    'faq.a6': 'Yes: EU hosting, GDPR compliance, export and deletion of your data in one click from “My account”.',
    'faq.q7': 'How do I join an OCQJ Rendez-vous?',
    'faq.q8': 'When is the Ulule crowdfunding campaign?',
    'faq.a8': 'From September 4 to November 7, 2026. Rewards include the book, educational resources, OCQJ Rendez-vous and Give Back initiatives. The “Support the project” button on the homepage takes you there.',
    'faq.q9': "I don't have a code yet: how do I stay informed?",
    'faq.a9': 'Fill in the “Want to follow the adventure?” form on the homepage: choose your profile (reader, parent, player, club, journalist, partner, ambassador) and what interests you (the book, an OCQJ Rendez-vous, or both). You will get the news first.',
    'faq.q10': "Where do I enter my book's invitation code?",
    'faq.a10': 'During the campaign (until November 10, 2026), the code form is on “The book” page. Afterwards, it returns to the homepage.',
    'faq.q11': "I'm a journalist or partner: where can I find official materials?",
    'faq.a11': 'The “Press” page offers the press kit and official visuals (flyer, banner, book jacket, author profile). The “Media” page offers the partnership dossier, the parents & youth guide and the social media cards.',
    'faq.q12': 'I represent a football club: how do I join the builders?',
    'faq.a12': 'Select the “A football club” profile in the homepage form, download the partnership dossier from the “Looking for builders” card, then apply via “Become a partner”.',
    'faq.a7': 'OCQJ Rendez-vous are announced on the Rendez-vous OCQJ page. Create an account and register in one click.',
    'faq.testimonialsTitle': 'They are living the adventure',
    'faq.t1Quote': 'My son re-reads his missions every evening. The platform turned his reading into a life project.',
    'faq.t1Author': 'Sophie, Léa’s mum (10)',
    'faq.t2Quote': 'The 10 keys give a concrete framework to talk about values with my U12 players.',
    'faq.t2Author': 'Claire, sports educator',
    'faq.t3Quote': 'I understood that even champions fail. Now I dare.',
    'faq.t3Author': 'Noah, 11',
    'crm.title': 'Outreach CRM',
    'crm.subtitle': 'Contact base, pipeline and mail-merge campaigns.',
    'crm.tabDashboard': 'Dashboard',
    'crm.tabContacts': 'Contacts',
    'crm.tabPipeline': 'Pipeline',
    'crm.tabCampaigns': 'Campaigns',
    'crm.tabTemplates': 'Templates',
    'crm.kpiContacts': 'Contacts',
    'crm.kpiSent': 'Emails sent',
    'crm.kpiEngaged': 'Engagement',
    'crm.kpiRelances': 'To follow up',
    'crm.contactRate': 'Contacts reached',
    'crm.engagementRate': 'Engagement rate',
    'crm.funnelTitle': 'Pipeline funnel',
    'crm.byCategory': 'Contacts by category',
    'crm.importBtn': 'Import the Excel file',
    'crm.importDone': '{imported} contacts imported ({duplicates} duplicates, {skipped} without email)',
    'crm.searchPlaceholder': 'Search (name, organisation, email)…',
    'crm.allCategories': 'All categories',
    'crm.allStages': 'All stages',
    'crm.newContact': 'New contact',
    'crm.detailTitle': 'Contact card',
    'crm.notes': 'Notes & history',
    'crm.notePlaceholder': 'Internal note…',
    'crm.moveTo': 'Move to',
    'crm.deleteContact': 'Delete this contact?',
    'crm.deleteContactText': 'The contact, its notes and message history will be permanently deleted.',
    'crm.unsubscribedBadge': 'Unsubscribed',
    'crm.lastSent': 'Last sent',
    'crm.relancesTitle': 'To follow up',
    'crm.relancesEmpty': 'No follow-up pending — everything is up to date.',
    'crm.daysAgo': '{n} d ago (follow-up at day {d})',
    'crm.newCampaign': 'New campaign',
    'crm.campaignName': 'Campaign name',
    'crm.campaignTemplate': 'Template',
    'crm.campaignSegment': 'Segment (empty = all contacts with an email)',
    'crm.campaignLang': 'Email language',
    'crm.create': 'Create',
    'crm.generate': 'Generate messages',
    'crm.generated': '{n} messages generated',
    'crm.launch': 'Launch sending',
    'crm.launchTitle': 'Launch the campaign?',
    'crm.launchText': '{n} emails will be sent in small batches (about 40/minute). This action is final.',
    'crm.cancelCampaign': 'Cancel campaign',
    'crm.cancelText': 'The {n} pending messages will be deleted.',
    'crm.previewSubject': 'Subject',
    'crm.statusDraft': 'Draft',
    'crm.statusGenerated': 'Ready',
    'crm.statusSending': 'Sending…',
    'crm.statusDone': 'Done',
    'crm.statusCancelled': 'Cancelled',
    'crm.statusError': 'Error',
    'crm.templatesIntro': 'Editorial kit templates — editable. Variables: {Prenom}, {Institution}, {Fonction}, {Email}.',
    'crm.editTemplate': 'Edit template',
    'crm.subjectFr': 'Subject (FR)',
    'crm.bodyFr': 'Body (FR)',
    'crm.subjectEn': 'Subject (EN)',
    'crm.bodyEn': 'Body (EN)',
    'crm.relanceDays': 'Follow up after (days)',
    'crm.savedTemplate': 'Template saved!',
    'crm.saved': 'Saved!',
    'crm.deleted': 'Contact deleted.',
    'crm.deleteCampaign': 'Delete campaign',
    'crm.deleteCampaignText': 'The campaign and its {n} messages will be permanently deleted.',
    'crm.campaignDeleted': 'Campaign deleted.',
    'footer.contact': 'Contact',
    'crm.dmOpen': 'Direct message',
    'crm.dmTitle': 'Write a direct message',
    'crm.dmRecipient': 'Recipient (email)',
    'crm.dmRecipientHelp': 'Search for an existing user or contact, or type a new email address.',
    'crm.dmSubject': 'Subject',
    'crm.dmBody': 'Your message…',
    'crm.dmLang': 'Language',
    'crm.dmSend': 'Send',
    'crm.dmSent': 'Message queued — it will be sent within a few minutes!',
    'crm.dmInvalid': 'A valid email, subject and message are required.',
    'contact.eyebrow': "Let's talk",
    'contact.title': 'Contact us',
    'contact.intro': 'A question about the book, an OCQJ Rendez-vous to organise, a partnership to imagine? Write to us: every message is read with care.',
    'contact.directTitle': 'Direct line',
    'contact.reply48': 'Dimitri personally answers every message, usually within 48 hours.',
    'contact.name': 'Your name',
    'contact.phone': 'Your phone number',
    'contact.email': 'Your email',
    'contact.subjectLabel': 'Your message is about…',
    'contact.subject.livre': 'The book',
    'contact.subject.masterclass': 'An OCQJ Rendez-vous',
    'contact.subject.partenariat': 'A partnership',
    'contact.subject.presse': 'Press',
    'contact.subject.autre': 'Something else',
    'contact.message': 'Your message…',
    'contact.submit': 'Send the message',
    'contact.success': 'Message received!',
    'contact.successSub': 'Thank you for your trust — Dimitri will personally reply very soon.',
    'contact.error': 'Something went wrong — try again or write directly to dimitri.mfoumou@gmail.com.',
    'crm.campaignCreated': 'Campaign created',
    'crm.launched': 'Sending launched — emails go out in batches.',
    'crm.stage.a_contacter': 'To contact',
    'crm.stage.envoye': 'Email sent',
    'crm.stage.relance': 'Followed up',
    'crm.stage.discussion': 'In discussion',
    'crm.stage.gagne': 'Partner won',
    'crm.stage.sans_suite': 'No follow-up',
    'crm.msgPending': 'Pending',
    'crm.msgSending': 'Sending…',
    'crm.msgSent': 'Sent',
    'crm.msgFailed': 'Failed',
    'crm.colContact': 'Contact',
    'crm.colCategory': 'Category',
    'crm.colStage': 'Stage',
    'crm.colEmail': 'Email',
    'crm.page': 'Page {page}/{pages}',
  },
  es: {
    'common.loading': 'Cargando…',
    'common.back': 'Volver',
    'common.backHome': 'Volver al inicio',
    'common.home': 'Inicio',
    'common.sending': 'Enviando…',
    'common.cancel': 'Cancelar',
    'common.error': 'Se produjo un error',
    'common.support': 'Apoyar el proyecto',
    'common.chapter': 'capítulo',
    'common.chapters': 'capítulos',
    'common.chapterN': 'Capítulo {n}',
    'nav.chapters': 'Mi aventura',
    'nav.diary': 'Mi diario',
    'nav.synthesis': 'Mi recorrido',
    'nav.parent': 'Mi hijo/a',
    'nav.educator': 'Mi grupo',
    'nav.admin': 'Back-office',
    'nav.crm': 'CRM',
    'footer.book': 'El libro',
    'footer.media': 'Medios',
    'footer.masterclass': 'Rendez-vous OCQJ !',
    'footer.about': 'Acerca de',
    'footer.access': 'Solicitar acceso',
    'footer.rgpd': 'Conforme al RGPD — diario de los jóvenes cifrado, ningún dato vendido.',
    'roles.jeune': 'Joven',
    'roles.parent': 'Padre/Madre',
    'roles.educateur': 'Educador',
    'roles.admin': 'Administrador',
    'axes.coeur': 'Emociones',
    'axes.sagesse': 'Sabiduría',
    'axes.phrase': 'Inspiración',
    'axes.mentor': 'Mentoría',
    'axes.dialogue': 'Diálogo',
    'axes.mission': 'Acción',
    'axes.carnet': 'Introspección',
    'axes.giveback': 'Transmisión',
    'axes.aventure': 'Apertura',
    'axes.projection': 'Proyección',
    'badges.premier-pas.label': 'Primer paso',
    'badges.premier-pas.hint': 'Terminar el capítulo 1',
    'badges.je-me-connais.label': 'Me conozco',
    'badges.je-me-connais.hint': 'Escribir 3 reflexiones en tu diario',
    'badges.je-me-releve.label': 'Me levanto',
    'badges.je-me-releve.hint': 'Terminar el capítulo 12 — el fracaso es un maestro',
    'badges.esprit-equipe.label': 'Espíritu de equipo',
    'badges.esprit-equipe.hint': 'Realizar 3 diálogos',
    'badges.mission-accomplie.label': 'Misión cumplida',
    'badges.mission-accomplie.hint': 'Cumplir tu primera misión de Eliano',
    'badges.je-remercie.label': 'Doy las gracias',
    'badges.je-remercie.hint': 'Terminar el capítulo 23 — la promesa a tus padres',
    'badges.je-transmets.label': 'Lo transmito',
    'badges.je-transmets.hint': 'Realizar tu primer Give Back',
    'badges.give-back.label': 'Give Back',
    'badges.give-back.hint': 'Realizar 3 acciones de transmisión',
    'badges.leader-positif.label': 'Líder positivo',
    'badges.leader-positif.hint': 'Terminar el capítulo 20 — el campeón empieza aquí',
    'badges.heritage.label': 'Legado',
    'badges.heritage.hint': 'Terminar los 28 capítulos — el relevo es tuyo',
    'landing.login': 'Ya tengo una cuenta',
    'landing.eyebrow': 'El precio del sueño deportivo — la aventura de Eliano',
    'landing.titleA': 'La aventura continúa ',
    'landing.titleB': 'después de la última página.',
    'landing.intro': 'El libro cuenta la historia de Eliano. La plataforma te la hace vivir: 28 capítulos, 10 claves por capítulo, tu Rueda del Legado y tu diario secreto.',
    'landing.codeLabel': 'Introduce el código de tu libro o tu código de invitación',
    'landing.codePlaceholder': 'ej.: OCQJ-XXXX-XXXX',
    'landing.submit': 'Entrar en la aventura',
    'landing.checking': 'Comprobando…',
    'landing.codeInvalid': 'Código no válido',
    'landing.qrHint': 'El código QR de tu libro abre directamente el capítulo correspondiente.',
    'landing.noCode': '¿No tienes código? Pide tu acceso →',
    'landing.communityPrefix': 'Ya',
    'landing.communitySuffix': 'realizados por la comunidad',
    'landing.givebackOne': 'Give Back',
    'landing.givebackMany': 'Give Backs',
    'landing.missionOne': 'misión',
    'landing.missionMany': 'misiones',
    'landing.and': 'y',
    'landing.f1t': 'Las 10 claves del Legado',
    'landing.f1d': 'Emociones, sabiduría, mentor, misión, Give Back… cada capítulo se convierte en una experiencia para vivir.',
    'landing.f2t': 'Tu Rueda del Legado',
    'landing.f2d': 'Un radar de 10 ramas que crece con tus acciones — nunca una nota, siempre una aventura.',
    'landing.f3t': 'El diario de Eliano',
    'landing.f3d': 'Lee lo que escribe Eliano y luego escribe tu propia historia en tu diario cifrado y privado.',
    'landing.security': 'Espacio seguro para los jóvenes: cuenta activada con la autorización de un padre. Diario cifrado.',
    'landing.supportCta': 'Apoyar el proyecto en Ulule',
    'landing.hero.title': "ON CROIT QU'ON JOUE !",
    'landing.hero.subtitle': 'El Precio del Sueño Deportivo',
    'landing.hero.baseline': 'Del sueño personal al legado colectivo',
    'landing.hero.quote': '«¿Se puede ser un gran campeón sin ser primero una buena persona?»',
    'landing.acts.title': 'Los 4 actos del libro',
    'landing.acts.1.title': 'Acto 1: El Sueño',
    'landing.acts.1.desc': 'La chispa inicial: el nacimiento de una vocación que trasciende lo cotidiano.',
    'landing.acts.2.title': 'Acto 2: Las Pruebas',
    'landing.acts.2.desc': 'El aprendizaje a través de la adversidad: crecer y forjarse en la dificultad.',
    'landing.acts.3.title': 'Acto 3: Las Decisiones',
    'landing.acts.3.desc': 'Tomar las riendas de tu destino y construir un futuro guiado por tus valores.',
    'landing.acts.4.title': 'Acto 4: La Transmisión',
    'landing.acts.4.desc': 'El verdadero legado de un campeón: lo que deja a la próxima generación.',
    'landing.pillars.title': 'Mucho más que una novela: una experiencia inédita',
    'landing.pillars.1.title': 'Novela ilustrada',
    'landing.pillars.1.desc': '28 capítulos inmersivos en el corazón de la búsqueda de uno mismo.',
    'landing.pillars.2.title': 'Recorrido pedagógico',
    'landing.pillars.2.desc': 'Retos, preguntas y reflexiones para acompañar el crecimiento.',
    'landing.pillars.3.title': 'Plataforma interactiva',
    'landing.pillars.3.desc': 'Una plataforma digital inédita: claves de reflexión, diario de sueños y recursos exclusivos para jóvenes, padres y educadores.',
    'landing.pillars.4.title': 'Música y audio',
    'landing.pillars.4.desc': 'Una banda sonora original compuesta para el libro, para escuchar durante la lectura — una primicia en la novela juvenil.',
    'landing.pillars.5.title': 'Estudio sobre el sueño',
    'landing.pillars.5.desc': 'Un análisis profundo de los engranajes de la ambición deportiva.',
    'landing.pillars.6.title': 'Rendez-vous OCQJ !',
    'landing.pillars.6.desc': 'Momentos de intercambio para crecer juntos.',
    'landing.audio.title': 'La banda sonora del libro',
    'landing.audio.desc': 'Una innovación: el libro tiene su propia música. Escucha estos dos extractos y sumérgete en la aventura antes de pasar la primera página.',
    'landing.audio.track1': 'Extracto n°1',
    'landing.audio.track2': 'Extracto n°2',
    'landing.audio.soon': 'Muy pronto — en fase de finalización.',
    'landing.mc.title': 'Rendez-vous OCQJ ! — 4 encuentros en línea',
    'landing.mc.subtitle': 'Para descubrir, intercambiar y construir juntos: cuatro veladas Zoom abiertas, de una hora cada una.',
    'landing.mc.ev1.date': 'Lunes 7 sept. 2026 · 20h00–21h00 (París)',
    'landing.mc.ev1.audience': 'Prensa & Medios',
    'landing.mc.ev1.objective': 'Dar a conocer el proyecto a los medios y crear los primeros relevos de prensa.',
    'landing.mc.ev1.subject': '¿Y si el fútbol fuera ante todo una escuela de vida?',
    'landing.mc.ev2.date': 'Lunes 14 sept. 2026 · 20h00–21h00 (París)',
    'landing.mc.ev2.audience': 'Socios & Ecosistema fútbol',
    'landing.mc.ev2.objective': 'Reunir a los primeros constructores: clubes, instituciones, marcas y fundaciones.',
    'landing.mc.ev2.subject': 'Te hago un pase. Te toca transformarlo.',
    'landing.mc.ev3.date': 'Lunes 21 sept. 2026 · 20h00–21h00 (París)',
    'landing.mc.ev3.audience': 'Padres & Educadores',
    'landing.mc.ev3.objective': 'Crear la adhesión de padres y educadores en torno a la dimensión educativa.',
    'landing.mc.ev3.subject': '¿Cómo acompañar el sueño de un joven sin perderse en él?',
    'landing.mc.ev4.date': 'Lunes 28 sept. 2026 · 20h00–21h00 (París)',
    'landing.mc.ev4.audience': 'Jóvenes & Padres',
    'landing.mc.ev4.objective': 'Hacer entrar a los jóvenes y sus familias en el universo de Eliano.',
    'landing.mc.ev4.subject': 'Y tú, ¿cuál es tu sueño?',
    'landing.mc.zoomTitle': 'Conexión Zoom — el mismo enlace para los 4 encuentros',
    'landing.mc.zoomId': 'ID de reunión: 856 9303 8418 · Código: 531726',
    'landing.mc.cta': 'Unirse a la reunión Zoom',
    'landing.action_band.1': 'LEER',
    'landing.action_band.2': 'COMPRENDER',
    'landing.action_band.3': 'ACTUAR',
    'landing.action_band.4': 'TRANSMITIR',
    'landing.masterclass.title': 'Los Rendez-vous OCQJ !',
    'landing.masterclass.subtitle': 'Encuentro participativo (60 a 90 min)',
    'landing.masterclass.points.1': 'Soñar sin perderse',
    'landing.masterclass.points.2': 'Aprender del fracaso',
    'landing.masterclass.points.3': 'Construir disciplina',
    'landing.masterclass.points.4': 'Elegir tu entorno',
    'landing.masterclass.points.5': 'Preparar el después del fútbol',
    'landing.masterclass.points.6': 'Liderazgo y transmisión',
    'landing.crowdfunding.title': 'Campaña Ulule',
    'landing.crowdfunding.subtitle': 'Del 4 de septiembre al 7 de noviembre de 2026',
    'landing.crowdfunding.desc': 'Participa en el lanzamiento de On croit qu’on joue ! y accede a recompensas exclusivas.',
    'landing.crowdfunding.points.1': 'Libros y recursos educativos',
    'landing.crowdfunding.points.2': 'Rendez-vous OCQJ ! e iniciativas Give Back',
    'landing.crowdfunding.points.3': 'Audio, vídeo y comunidad comprometida',
    'landing.giveback.title': 'El Give Back',
    'landing.giveback.desc': 'Transmitir, compartir, incluir. Ofrecemos libros y recursos a los jóvenes que más lo necesitan, junto con los clubes y socios.',
    'landing.batisseurs.title': 'Busco constructores',
    'landing.batisseurs.desc': 'Socios, clubes, educadores, padres, empresas… únete a una aventura útil para la juventud.',
    'landing.batisseurs.cta': 'Convertirse en socio',
    'landing.batisseurs.dossier': 'Dossier de colaboración (PDF)',
    'landing.lead.profile.club': 'Un club de fútbol',
    'landing.author.name': "Dimitri M'Foumou-Titi",
    'landing.author.role': 'Autor',
    'landing.author.quote': '«¡Juntos, hagamos del fútbol una escuela de vida y un legado colectivo!»',
    'landing.closing': 'Apoyar el proyecto es contribuir a escribir el futuro de nuestros jóvenes.',
    'landing.lead.title': '¿Quieres seguir la aventura?',
    'landing.lead.desc': 'Deja tus datos: recibirás antes que nadie las novedades del libro, los Rendez-vous OCQJ y el lanzamiento.',
    'landing.lead.titleM': '¡El sitio llega muy pronto!',
    'landing.lead.descM': 'Estamos ultimando la plataforma. Deja tus datos: serás de los primeros en conocer el lanzamiento, el libro y los Rendez-vous OCQJ.',
    'maintenance.badge': 'Mantenimiento en curso',
    'maintenance.title': '¡Volvemos enseguida!',
    'maintenance.subtitle': 'El sitio está temporalmente en mantenimiento. Mientras tanto, mira el vídeo del proyecto y déjanos tu email para enterarte del lanzamiento.',
    'landing.lead.name': 'Tu nombre y apellido',
    'landing.lead.email': 'Tu email',
    'landing.lead.profileLabel': 'Eres…',
    'landing.lead.profile.lecteur': 'Futuro lector',
    'landing.lead.profile.parent': 'Padre/Madre',
    'landing.lead.profile.journaliste': 'Periodista',
    'landing.lead.profile.joueur': 'Jugador/a',
    'landing.lead.profile.partenaire': 'Socio',
    'landing.lead.profile.ambassadeur': 'Embajador/a',
    'landing.lead.interestLabel': 'Lo que te interesa',
    'landing.lead.interest.livre': 'El libro',
    'landing.lead.interest.masterclass': 'Un Rendez-vous OCQJ !',
    'landing.lead.interest.les_deux': 'Ambos',
    'landing.lead.submit': 'Mantenerme informado',
    'landing.lead.success': '¡Gracias! Ya formas parte de la aventura — hasta pronto.',
    'landing.lead.rgpd': 'Tus datos solo sirven para mantenerte informado. Baja en un clic, en cualquier momento.',
    'landing.lead.error': 'Se ha producido un error — inténtalo de nuevo.',
    'landing.lead.hasCode': '¿Ya tienes el libro? Introduce tu código →',
    'landing.lead.backToForm': '← Volver al formulario de información',
    'landing.videoTitle': 'La aventura en vídeo',
    'footer.privacy': 'Privacidad',
    'footer.legal': 'Aviso legal',
    'footer.press': 'Prensa',
    'press.eyebrow': 'Espacio de medios',
    'press.title': 'Prensa y visuales oficiales',
    'press.intro': "Aquí encontrarás los visuales oficiales del proyecto «On croit qu'on joue ! — El Precio del Sueño Deportivo», de libre uso para tus artículos y publicaciones (crédito: Dimitri M'Foumou-Titi).",
    'press.visual1': 'Flyer «Masterclass inspiradoras»',
    'press.visual2': 'Banner oficial del proyecto',
    'press.visual3': 'Portada de la novela',
    'press.visual4': 'Retrato del autor',
    'press.download': 'Descargar',
    'press.ficheAuteur': 'Descargar la ficha del autor',
    'press.contactTitle': 'Contacto de prensa',
    'press.docsTitle': 'Documentos oficiales',
    'press.visualsTitle': 'Visuales oficiales',
    'press.doc1': 'Dossier de colaboración',
    'press.doc2': 'Dossier de prensa',
    'press.doc3': 'Guía para padres y jóvenes jugadores',
    'press.doc4': 'Tarjetas para redes sociales',
    'press.aud1': 'Socios',
    'press.aud2': 'Prensa',
    'press.aud3': 'Padres y jóvenes',
    'press.aud4': 'Redes sociales',
    'media.docsTitle': 'Documentos para descargar',
    'legal.eyebrow': 'Información legal',
    'legal.title': 'Aviso legal',
    'legal.intro': 'Última actualización: junio de 2026. Información legal relativa al sitio y a la plataforma «On croit qu\'on joue ! — El Precio del Sueño Deportivo».',
    'legal.s1Title': '1. Editor del sitio',
    'legal.s1Body': "Dimitri M'Foumou-Titi, autor y editor del proyecto «On croit qu'on joue !» (empresario individual, Francia).\nSIREN: 991 741 075 — SIRET: 991 741 075 00014 — Código APE: 90.03B (otra creación artística).\nInscrito en el Registro Nacional de Empresas francés (RNE) el 23/09/2025.\nDomicilio social: 4 Cité Croix Saint-Simon, 78100 Saint-Germain-en-Laye — Francia.\nContacto: dimitri.mfoumou@gmail.com — +33 6 98 69 75 58.",
    'legal.s2Title': '2. Director de la publicación',
    'legal.s2Body': "Dimitri M'Foumou-Titi.",
    'legal.s3Title': '3. Alojamiento',
    'legal.s3Body': 'El sitio está alojado en una infraestructura cloud en contenedores operada por la plataforma de despliegue. Los datos se alojan preferentemente dentro de la Unión Europea.',
    'legal.s4Title': '4. Propiedad intelectual',
    'legal.s4Body': 'Todo el contenido del sitio y de la obra «On croit qu\'on joue ! — El Precio del Sueño Deportivo» (textos, ilustraciones, identidad visual, músicas, vídeos) está protegido por el derecho de autor. Queda prohibida cualquier reproducción, representación o difusión, total o parcial, sin autorización previa por escrito.',
    'legal.s5Title': '5. Datos personales',
    'legal.s5Body': 'El tratamiento de los datos personales (cuentas, progreso, diario cifrado, prospección) se describe en la Política de privacidad, accesible más abajo y desde el pie de página.',
    'legal.s6Title': '6. Enlaces externos',
    'legal.s6Body': 'El sitio contiene enlaces a servicios de terceros (Ulule, YouTube, LinkedIn). El editor no es responsable de sus contenidos ni de sus prácticas.',
    'legal.s7Title': '7. Derecho aplicable',
    'legal.s7Body': 'Este sitio se rige por el derecho francés. En caso de litigio, y tras intentar una resolución amistosa, los tribunales franceses serán los únicos competentes.',
    'privacy.eyebrow': 'RGPD — tus datos, tus derechos',
    'privacy.title': 'Política de privacidad',
    'privacy.intro': 'Última actualización: junio de 2026. Esta política explica qué datos trata la plataforma «On croit qu\'on joue ! — El Precio del Sueño Deportivo» y cuáles son tus derechos.',
    'privacy.s1Title': '1. Responsable del tratamiento',
    'privacy.s1Body': "Dimitri M'Foumou-Titi, editor del proyecto «On croit qu'on joue !».\nContacto: dimitri.mfoumou@gmail.com — +33 6 98 69 75 58.",
    'privacy.s2Title': '2. Datos tratados',
    'privacy.s2Body': "Cuentas de usuario: email, nombre o apodo, rol (joven, padre/madre, educador, admin).\nProgreso pedagógico: claves validadas, Rueda del Legado, insignias.\nDiario personal del joven: contenido cifrado (AES-256-GCM), ilegible para el equipo.\nFotos «Give Back»: publicadas únicamente con el acuerdo del usuario.\nProspección: datos de contacto profesionales (contactos importados o del formulario de inicio), historial de envíos y seguimientos.\nRegistros técnicos: auditoría de administración y limitación de tasa (antiabuso).",
    'privacy.s3Title': '3. Finalidades',
    'privacy.s3Body': "Proporcionar la plataforma pedagógica y seguir el progreso de los jóvenes.\nVerificar el consentimiento parental antes de activar cualquier cuenta de joven.\nEnviar las comunicaciones solicitadas (libro, Rendez-vous OCQJ) y las campañas de prospección validadas por el editor.\nGarantizar la seguridad y fiabilidad del servicio.",
    'privacy.s4Title': '4. Bases legales',
    'privacy.s4Body': "Ejecución del contrato: creación de cuenta y recorrido pedagógico.\nConsentimiento: diario personal, fotos Give Back, formulario de contacto de inicio.\nInterés legítimo: prospección profesional, seguridad, estadísticas de uso anonimizadas.",
    'privacy.s5Title': '5. Plazos de conservación',
    'privacy.s5Body': "Cuenta: durante la vida de la cuenta y hasta 3 años tras la última actividad.\nDiario cifrado: se elimina con la cuenta, sin copia legible.\nProspección: 3 años tras el último intercambio; la baja surte efecto inmediato.\nRegistros técnicos: 12 meses máximo.",
    'privacy.s6Title': '6. Encargados del tratamiento',
    'privacy.s6Body': "Alojamiento de la aplicación y base de datos (MongoDB), envío de emails transaccionales (Resend), almacenamiento seguro de archivos. Damos prioridad al tratamiento dentro de la Unión Europea.",
    'privacy.s7Title': '7. Tus derechos',
    'privacy.s7Body': "Tienes derechos de acceso, rectificación, supresión, portabilidad, limitación y oposición.\nDesde «Mi cuenta»: exportación JSON de tus datos y eliminación definitiva de la cuenta.\nProspección: enlace de baja de un clic presente en cada email.\nPor email: dimitri.mfoumou@gmail.com. También puedes acudir a la CNIL (cnil.fr).",
    'privacy.s8Title': '8. Protección de menores',
    'privacy.s8Body': "La cuenta de un joven solo se activa tras el consentimiento parental verificable (enlace firmado enviado al padre/madre, válido 72 h).\nEl padre/madre sigue el progreso de su hijo pero nunca accede a su diario personal cifrado.",
    'privacy.s9Title': '9. Seguridad y cookies',
    'privacy.s9Body': "Conexión mediante código de un solo uso enviado por email: no se almacena ninguna contraseña.\nArchivos servidos con URLs firmadas (validez de 15 minutos), limitación de tasa y registro de auditoría de las acciones de administración.\nSin cookies de terceros ni rastreadores publicitarios: solo se guardan preferencias locales (sesión, idioma) en tu navegador.",
    'book.codeTitle': '¿Tienes el libro? Introduce tu código',
    'book.givebackTitle': 'El Give Back en acción',
    'admin.tabSettings': 'Ajustes',
    'admin.setTitle': 'Ajustes del sitio',
    'admin.setVideo': 'Vídeo de la página principal',
    'admin.setVideoHelp': 'Enlace de YouTube o archivo .mp4 — se muestra junto al formulario de inicio. Dejar vacío para ocultar el vídeo.',
    'admin.settingsSaved': '¡Ajustes guardados!',
    'admin.setPages': 'Páginas públicas (activación)',
    'admin.setAudio1': 'Extracto de audio 1 (archivo MP3)',
    'admin.setAudio2': 'Extracto de audio 2 (archivo MP3)',
    'admin.setAudioHelp': 'Pega una ruta local o una URL https, o sube el archivo MP3 desde tu ordenador con el botón (25 MB máx.). Los extractos aparecen en la sección «Mucho más que una novela» de la landing.',
    'admin.audioUpload': 'Subir MP3',
    'admin.audioTitlePh': 'Título de la canción mostrado en la landing (ej.: El canto del campo)',
    'admin.audioUploaded': '¡Archivo subido! Haz clic en Guardar para aplicarlo.',
    'admin.audioInvalid': 'Solo se aceptan archivos .mp3',
    'admin.audioTooBig': 'Archivo demasiado grande (25 MB máx.)',
    'admin.mcEventsTitle': 'Rendez-vous OCQJ ! — 4 encuentros en línea (landing)',
    'admin.mcEventsHelp': 'Vacío = texto por defecto (traducido FR/EN/ES). Tu texto sustituye al mostrado. La visibilidad de la sección sigue el interruptor «Rendez-vous OCQJ !» de las páginas públicas de arriba.',
    'admin.mcEvTitle': 'Encuentro n.º {n}',
    'admin.analyticsTitle': 'Analítica de la plataforma',
    'admin.an.users': 'Cuentas activas',
    'admin.an.pendingConsent': 'Pendientes de consentimiento',
    'admin.an.signups7': 'Registros (7 d)',
    'admin.an.signups30': 'Registros (30 d)',
    'admin.an.chapters': 'Capítulos terminados',
    'admin.an.keys': 'Claves respondidas',
    'admin.an.diary': 'Entradas de diario',
    'admin.an.family': 'Vínculos familiares',
    'admin.an.consents': 'Consentimientos pendientes',
    'admin.an.requests': 'Solicitudes de acceso pendientes',
    'admin.an.crm': 'Contactos CRM',
    'admin.an.mc': 'Inscripciones Rendez-vous OCQJ',
    'admin.an.messages': 'Mensajes de contacto',
    'admin.an.recent': 'Últimos registros',
    'admin.an.empty': 'Sin registros recientes',
    'admin.maintenanceMode': 'Modo mantenimiento',
    'admin.maintenanceHelp': 'Cuando está activado, todo el sitio público muestra una pantalla de mantenimiento con el formulario «¿Quieres seguir la aventura?». Sigues conectado como admin.',
    'admin.setContent': 'Contenido editable (sustituye los textos por defecto)',
    'admin.contentEmpty': 'Vacío = texto por defecto',
    'admin.pageToggle.page_livre': 'Página «El libro»',
    'admin.pageToggle.page_medias': 'Página «Medios»',
    'admin.pageToggle.page_masterclass': 'Página «Rendez-vous OCQJ !»',
    'admin.pageToggle.page_apropos': 'Página «Acerca de»',
    'admin.pageToggle.page_faq': 'Página «FAQ»',
    'admin.pageToggle.page_presse': 'Página «Prensa»',
    'admin.pageToggle.page_contact': 'Página «Contacto»',
    'admin.contentField.content_landing_quote': 'Cita del hero (portada)',
    'admin.contentField.content_landing_closing': 'Banner final (portada)',
    'admin.contentField.content_contact_reply48': 'Promesa de respuesta (página Contacto)',
    'page.disabled': 'Página temporalmente no disponible — ¡vuelve pronto!',
    'login.title': 'Iniciar sesión',
    'login.email': 'Tu email',
    'login.emailPlaceholder': 'tu@ejemplo.com',
    'login.noPassword': 'Sin contraseña: te enviamos un código de 6 dígitos por email.',
    'login.requestCode': 'Recibir mi código',
    'login.codeSent': '¡Acabamos de enviar un código!',
    'login.sendError': 'No se pudo enviar el código',
    'login.codeSentTo': 'Se ha enviado un código de 6 dígitos a {email} (válido 10 minutos).',
    'login.devMode': 'Modo demo — código: {code}',
    'login.submit': 'Conectarme',
    'login.invalidCode': 'Código no válido',
    'login.changeEmail': 'Cambiar de email',
    'login.noAccount': 'No hay ninguna cuenta activa para este email. Si tu solicitud fue aceptada, haz clic en "Crear mi cuenta" en el email recibido: la cuenta solo existe una vez completada la inscripción.',
    'login.noAccountCta': 'Solicitar acceso',
    'login.pendingConsent': 'Tu cuenta aún espera la autorización de un padre: debe hacer clic en el enlace recibido por email para activarla.',
    'ambProfile.title': 'Tu perfil de embajador',
    'ambProfile.intro': '¡Bienvenido al Team Héritage! Añade tu foto y tus redes sociales: serán validados por el equipo.',
    'ambProfile.photoLabel': 'Tu foto',
    'ambProfile.photoChoose': 'Elegir una foto',
    'ambProfile.photoHelp': 'JPG, PNG o WebP — 5 MB máx.',
    'ambProfile.photoUpload': 'Enviar la foto',
    'ambProfile.photoUploaded': '¡Foto enviada!',
    'ambProfile.photoInvalid': 'Formatos aceptados: JPG, PNG o WebP',
    'ambProfile.photoTooBig': 'Foto demasiado pesada (5 MB máx.)',
    'ambProfile.linksTitle': 'Tus redes sociales (opcional)',
    'ambProfile.linksHelp': 'Se proponen 2 enlaces, puedes añadir hasta 5.',
    'ambProfile.url': 'Enlace (https://…)',
    'ambProfile.addLink': 'Añadir un enlace',
    'ambProfile.save': 'Guardar mis enlaces',
    'ambProfile.saved': '¡Perfil guardado!',
    'ambProfile.pendingReview': 'Perfil enviado: será validado por el equipo.',
    'ambProfile.approved': '¡Tu perfil está validado por el equipo!',
    'ambProfile.rejected': 'El equipo rechazó tu perfil: puedes modificarlo y reenviarlo.',
    'ambProfile.notFound': 'Enlace inválido o caducado. Contáctanos si crees que es un error.',
    'ambProfile.networks.instagram': 'Instagram',
    'ambProfile.networks.tiktok': 'TikTok',
    'ambProfile.networks.linkedin': 'LinkedIn',
    'ambProfile.networks.youtube': 'YouTube',
    'ambProfile.networks.other': 'Otro',
    'admin.ambassadorProfileTitle': 'Ver el perfil (foto + redes)',
    'admin.profileReviewTitle': 'Perfil de embajador',
    'admin.approveProfile': 'Aprobar el perfil',
    'admin.rejectProfile': 'Rechazar el perfil',
    'admin.profileApproved': 'Perfil aprobado',
    'admin.profileRejected': 'Perfil rechazado',
    'admin.noProfileYet': 'Sin foto ni enlaces por el momento.',
    'admin.onLanding': 'Perfil validado',
    'admin.accessJeuneAuto': 'Validación automática de las solicitudes de « Lector/a »',
    'admin.accessJeuneAutoHelp': 'ON: el enlace « Crear mi cuenta » se envía inmediatamente. OFF: la solicitud espera tu validación manual. Las solicitudes de Padre y Educador son siempre automáticas.',
    'admin.autoBadge': 'Auto',
    'landing.amb.eyebrow': 'Team Héritage',
    'landing.amb.title': 'Nuestros embajadores',
    'landing.amb.subtitle': 'Comparten la aventura de Eliano a su alrededor.',
    'side.upcomingTitle': 'Próximos Rendez-vous',
    'side.upcomingEmpty': 'Ningún rendez-vous próximo por el momento.',
    'side.allEvents': 'Ver todos los Rendez-vous',
    'side.newsTitle': 'Noticias en vídeo',
    'side.newsText': 'Mensajes y novedades del equipo para toda la red.',
    'admin.setNetworkVideo': 'Vídeo de noticias de la red (URL YouTube — mostrado en los espacios conectados)',
    'registerYouth.title': 'Únete a la aventura de Eliano',
    'registerYouth.name': 'Tu nombre',
    'registerYouth.namePlaceholder': 'ej.: Léa',
    'registerYouth.age': 'Tu edad',
    'registerYouth.agePlaceholder': 'ej.: 10',
    'registerYouth.parentEmail': 'El email de tu padre o madre',
    'registerYouth.parentEmailPlaceholder': 'padre@ejemplo.com',
    'registerYouth.note': 'Tu padre o madre recibirá un email para autorizar la creación de tu cuenta. Tu diario personal seguirá siendo secreto, incluso para ellos.',
    'registerYouth.submit': 'Pedir autorización',
    'registerYouth.successTitle': '¡Casi listo!',
    'registerYouth.successText': 'Acabamos de enviar un email a tu padre o madre a {email}. En cuanto den su autorización, recibirás un email para conectarte.',
    'registerAdult.title': 'Zona de adultos',
    'registerAdult.name': 'Su nombre',
    'registerAdult.namePlaceholder': 'ej.: Sophie Martin',
    'registerAdult.email': 'Su email',
    'registerAdult.emailPlaceholder': 'usted@ejemplo.com',
    'registerAdult.note': 'Tras enviar el formulario, recibirá un código de 6 dígitos por email para confirmar su dirección — después su cuenta estará activa y conectada.',
    'registerYouth.noteAdult': 'Tienes 18 años o más: tu cuenta se activará en cuanto verifiques tu email, sin autorización parental.',
    'registerYouth.noteNeutral': 'Indica tu edad: si tienes menos de 18 años, se pedirá por email la autorización de un padre o madre; si no, tu cuenta se activará directamente.',
    'registerYouth.otpTitle': 'Verifica tu email',
    'registerAdult.otpTitle': 'Verifique su email',
    'register.otpLabel': 'Código de verificación',
    'register.otpSubmit': 'Confirmar mi registro',
    'register.otpBack': 'Modificar mis datos',
    'register.codeLabel': 'Código de invitación (recibido por email)',
    'registerAdult.submit': 'Crear mi cuenta',
    'registerAdult.creating': 'Creando…',
    'registerAdult.created': '¡Cuenta de {role} creada! Inicie sesión.',
    'registerAdult.roleEducateur': 'Educador / Responsable',
    'requestAccess.title': 'Solicitar mi acceso',
    'requestAccess.intro': 'La aventura se une por invitación (código del libro o de un responsable). ¿No tienes? Dinos quién eres: te enviaremos uno si se acepta tu solicitud.',
    'requestAccess.name': 'Tu nombre',
    'requestAccess.namePlaceholder': 'ej.: Noah',
    'requestAccess.email': 'Tu email',
    'requestAccess.roleLabel': 'Te unes a la aventura como…',
    'requestAccess.roleJeune': 'Lector/a',
    'requestAccess.roleParent': 'Padre/Madre',
    'requestAccess.roleEducateur': 'Educador / Entrenador',
    'requestAccess.motivation': 'Tu motivación (opcional)',
    'requestAccess.motivationPlaceholder': 'ej.: leo el libro con mi club…',
    'requestAccess.submit': 'Enviar mi solicitud',
    'requestAccess.successTitle': '¡Solicitud enviada!',
    'requestAccess.successText': '¡Solicitud enviada! Revisa tu bandeja ({email}): el enlace para crear tu cuenta llega por email.',
    'consent.error': 'Este enlace de autorización no es válido o ha caducado.',
    'consent.title': 'Autorización parental',
    'consent.intro': '{name}{age} desea unirse a la aventura On croit qu’on joue ! junto a Eliano.',
    'consent.ageSuffix': ' ({age} años)',
    'consent.b1': '28 capítulos del libro prolongados por 10 claves de experiencia cada uno',
    'consent.b2': 'Un diario personal cifrado, legible únicamente por su hijo/a',
    'consent.b3': 'Podrá seguir su progreso desde su zona de padres',
    'consent.b4': 'Conforme al RGPD.',
    'consent.approve': 'Autorizo',
    'consent.refuse': 'Rechazo',
    'consent.approvedTitle': '¡Gracias!',
    'consent.approvedText': 'La cuenta de {name} está activada. Acabamos de enviarle un email para conectarse. Usted también puede conectarse con su email ({email}) para seguir su progreso.',
    'consent.refusedTitle': 'Anotado',
    'consent.refusedText': 'La cuenta no se activará. No se conservará ningún dato adicional.',
    'book.eyebrow': 'La novela',
    'book.subtitle': 'El precio del sueño deportivo',
    'book.p1': 'La historia de Eliano, un joven futbolista que descubre que el verdadero precio de un sueño no es la victoria, sino en quién te conviertes al perseguirlo. Una novela literaria y deportiva en 28 capítulos, pensada para los jóvenes y sus familias.',
    'book.p2': 'Cada capítulo continúa en la plataforma con 10 claves del Legado: emociones, sabiduría, carta de un mentor, diálogo en familia, misión para vivir, Give Back…',
    'book.f1t': '28 capítulos',
    'book.f1d': 'en 4 actos, del primer sueño a la transmisión',
    'book.f2t': '10 claves',
    'book.f2d': 'una experiencia pedagógica por capítulo',
    'book.f3t': 'En familia',
    'book.f3d': 'preguntas para hablar juntos',
    'book.f4t': 'Give Back',
    'book.f4d': 'cada lector se convierte en transmisor',
    'book.cta': 'Unirse a la aventura',
    'media.eyebrow': 'Medios',
    'media.title': 'El proyecto en los medios',
    'media.intro': '« On croit qu’on joue ! » es más que una novela: es un movimiento educativo que une deporte, valores y transmisión. Encuentre aquí los contenidos oficiales del proyecto.',
    'media.f1t': 'Las canciones oficiales',
    'media.f1d': 'Cada capítulo tiene su canción oficial, por descubrir en la zona joven.',
    'media.f2t': 'Pódcasts y extractos de audio',
    'media.f2d': 'Lecturas y testimonios para prolongar la historia en voz alta.',
    'media.f3t': 'Vídeos pedagógicos',
    'media.f3d': 'Contenidos cortos sobre las 10 claves del Legado.',
    'media.f4t': 'Dossier de prensa',
    'media.f4d': 'Dossier de prensa y visuales oficiales para descargar en la página Prensa.',
    'about.eyebrow': 'Acerca de',
    'about.title': 'Un libro, una plataforma, un movimiento',
    'about.intro': '« On croit qu’on joue ! » nació de una convicción: los valores del deporte — coraje, escucha, transmisión — también se aprenden con las historias. La novela cuenta la aventura de Eliano; la plataforma la convierte en experiencia vivida, en familia o en el club.',
    'about.v1t': 'Benevolencia',
    'about.v1d': 'Un espacio pensado para los jóvenes: lúdico, alentador, sin juicios ni notas.',
    'about.v2t': 'Seguridad',
    'about.v2d': 'Consentimiento parental obligatorio, diario cifrado de extremo a extremo, alojamiento UE, conforme al RGPD.',
    'about.v3t': 'Transmisión',
    'about.v3d': 'La filosofía Give Back: cada joven que crece ayuda a otro a empezar.',
    'about.teamTitle': 'El Equipo Legado',
    'about.teamText': 'Padres, entrenadores, educadores, jóvenes relevos: conviértase en embajador del proyecto. Su misión: dar a conocer la aventura de Eliano a su alrededor y ayudar a otros jóvenes a empezar. Envíe su candidatura:',
    'about.ambName': 'Su nombre',
    'about.ambEmail': 'Su email',
    'about.ambOrg': 'Club / escuela / asociación (opcional)',
    'about.ambMessage': '¿Por qué desea unirse al Equipo Legado?',
    'about.ambSubmit': 'Enviar candidatura al Equipo Legado',
    'about.ambSuccessTitle': '¡Candidatura enviada!',
    'about.ambSuccessText': 'El equipo le responderá por email a {email}.',
    'about.supportTitle': 'Apoyar el proyecto',
    'about.supportText': 'Este proyecto se financia mediante micromecenazgo: cada apoyo ayuda a llevar la aventura de Eliano a más jóvenes.',
    'about.clubTitle': '¿Es usted un club, una escuela, una asociación?',
    'about.clubText': 'Únase a los clubes piloto y abra la aventura a sus jóvenes. Solicite su acceso, le responderemos rápidamente.',
    'about.clubCta': 'Solicitar acceso',
    'masterclass.eyebrow': 'Rendez-vous OCQJ !',
    'masterclass.title': 'Encuentros en torno a la aventura de Eliano',
    'masterclass.intro': 'Rendez-vous OCQJ animados con los mentores del libro: deporte, valores, transmisión. Padres, educadores y jóvenes son bienvenidos.',
    'masterclass.full': 'Completo',
    'masterclass.placeOne': 'Queda {n} plaza',
    'masterclass.placeMany': 'Quedan {n} plazas',
    'masterclass.registered': '{count}/{capacity} inscritos',
    'masterclass.alreadyRegistered': '¡Inscrito/a — hasta pronto!',
    'masterclass.register': 'Me inscribo',
    'masterclass.loginToRegister': 'Conéctate para inscribirte',
    'masterclass.toastAlready': '¡Ya estás inscrito/a!',
    'masterclass.toastConfirmed': '¡Inscripción confirmada — revisa tus emails!',
    'masterclass.emptyTitle': 'Ningún rendez-vous programado por el momento.',
    'masterclass.emptyText': 'Las próximas fechas se anunciarán aquí.',
    'account.title': 'Mi cuenta',
    'account.subtitle': 'Tu información y tus derechos RGPD.',
    'account.profile': 'Perfil',
    'account.name': 'Nombre',
    'account.email': 'Email',
    'account.role': 'Rol',
    'account.age': 'Edad',
    'account.ageValue': '{age} años',
    'account.exportTitle': 'Mis datos (derecho de acceso)',
    'account.exportText': 'Descarga un archivo JSON con todos tus datos: cuenta, progreso, claves del Legado, diario (descifrado solo para ti), inscripciones a Rendez-vous OCQJ.',
    'account.exportBtn': 'Exportar mis datos',
    'account.exportOk': '¡Tus datos se han descargado!',
    'account.exportError': 'Error al exportar',
    'account.deleteTitle': 'Eliminar mi cuenta (derecho de supresión)',
    'account.deleteText': 'Eliminación definitiva: cuenta, diario, progreso, inscripciones y vínculos familiares. Esta acción es irreversible.',
    'account.deleteBtn': 'Eliminar definitivamente',
    'account.deleteOk': 'Cuenta y datos eliminados. ¡Quizá hasta pronto!',
    'account.deleteDialogTitle': '¿Eliminar tu cuenta?',
    'account.deleteDialogText': 'Todos tus datos (diario, progreso, insignias) se borrarán definitivamente. Esta acción es irreversible.',
    'account.deleteConfirm': 'Sí, eliminar todo',
    'account.deleting': 'Eliminando…',
    'account.rgpdNote': 'Conforme al RGPD: alojamiento UE, diario cifrado, ningún dato vendido ni compartido.',
    'youth.eyebrow': 'Mi Espacio Legado',
    'youth.welcome': 'Bienvenido/a {name}.',
    'youth.question': '¿Dónde estás en tu aventura?',
    'youth.progressLabel': '% del recorrido pedagógico realizado',
    'youth.chapterProgress': 'Capítulo {current} / 28',
    'youth.weeklySuggestion': 'Esta semana, Eliano te invita a trabajar: {axis}.',
    'youth.statChapters': 'Capítulos',
    'youth.statExperiences': 'Experiencias',
    'youth.statMissions': 'Misiones',
    'youth.statCarnet': 'Notas del diario',
    'youth.continue': 'Continuar la aventura',
    'youth.myRadar': 'Mi Rueda del Legado',
    'youth.myDiary': 'Mi diario secreto',
    'youth.myDiarySub': 'Cifrado — visible solo para ti',
    'youth.myJourney': 'Mi recorrido',
    'youth.myJourneySub': 'Síntesis de los 28 capítulos',
    'youth.myBadges': 'Mis insignias',
    'parent.hello': 'Hola {name}',
    'parent.intro': 'Siga el progreso de su hijo/a en la aventura de Eliano. Su diario permanece cifrado y privado.',
    'parent.years': '{age} años',
    'parent.consentAt': 'Consentimiento otorgado el {date}',
    'parent.chaptersCount': '{done}/{total} capítulos',
    'parent.progression': 'Capítulos terminados',
    'parent.radar': 'Rueda del Legado',
    'parent.noChildrenTitle': 'Ningún hijo/a vinculado a su cuenta por el momento.',
    'exchange.sectionTitle': 'Temas de conversación y retos',
    'exchange.generalIntro': 'Ideas para conversar y lanzarse retos — ¡cada uno puede desafiar al otro!',
    'exchange.general': 'Temas generales',
    'exchange.byChapter': 'Por capítulo (según su progreso)',
    'exchange.chapterN': 'Capítulo {n}',
    'exchange.challengeLabel': 'Reto mutuo',
    'exchange.launch': 'Lanzar este reto',
    'exchange.launched': '¡Reto lanzado! El joven lo ve en su espacio.',
    'exchange.active': 'Retos lanzados',
    'exchange.launchedBadge': 'En curso',
    'exchange.doneBadge': 'Superado',
    'exchange.markDone': 'Marcar como superado',
    'exchange.reopen': 'Reabrir',
    'exchange.empty': 'Ningún tema por el momento.',
    'youth.challengesTitle': 'Retos para ti',
    'youth.challengeFrom': '{name} te desafía:',
    'youth.challengeStatusDone': '¡Superado!',
    'youth.challengeStatusLaunched': 'Por superar',
    'admin.tabTopics': 'Temas',
    'admin.topicsCount': '{n} temas de conversación',
    'admin.topicNew': 'Nuevo tema',
    'admin.topicChapter': 'Capítulo vinculado',
    'admin.topicGeneral': 'General (todos los jóvenes)',
    'admin.topicTitle': 'Título del tema',
    'admin.topicPrompt': 'Pregunta para suscitar el intercambio',
    'admin.topicChallenge': 'Reto mutuo propuesto',
    'admin.topicSaved': '¡Tema guardado!',
    'admin.topicDeleted': 'Tema eliminado',
    'admin.topicDeleteTitle': '¿Eliminar este tema?',
    'admin.topicDeleteText': 'El tema ya no se propondrá a padres y educadores.',
    'admin.colChapter': 'Capítulo',
    'admin.colPrompt': 'Pregunta',
    'admin.colChallenge': 'Reto',
    'parent.noChildrenText': 'El vínculo se crea automáticamente cuando autoriza la inscripción de su hijo/a.',
    'diary.title': 'Mi diario de juego',
    'diary.subtitle': 'Cifrado — ni siquiera los adultos pueden leerlo.',
    'diary.export': 'Exportar en PDF',
    'diary.new': 'Nueva página',
    'diary.titlePlaceholder': 'Título de mi página…',
    'diary.bodyPlaceholder': 'Cuenta tu día, tus ideas, tus sueños…',
    'diary.save': 'Escribir en el diario',
    'diary.saved': '¡Está escrito en tu diario!',
    'diary.deleted': '¡Página arrancada!',
    'diary.exported': '¡Tu diario se ha descargado!',
    'diary.reflections': 'Mis reflexiones de capítulos',
    'diary.myNotebook': 'Mi diario',
    'diary.beforeTurning': 'Antes de pasar la página',
    'diary.untitled': 'Sin título',
    'diary.empty': 'Tu diario espera tu primera historia…',
    'synthesis.lockedTitle': 'Tu historia empieza pronto',
    'synthesis.lockedText': 'La síntesis « Tu historia empieza ahora » se desbloquea tras el capítulo 28.',
    'synthesis.youCompleted': 'Has terminado',
    'synthesis.outOf': 'de {total}.',
    'synthesis.continue': 'Continuar la aventura',
    'synthesis.eyebrow': 'Síntesis de los 28 capítulos',
    'synthesis.title': 'Tu historia empieza ahora',
    'synthesis.subtitle': 'Ahora… te toca a ti.',
    'synthesis.overall': 'Recorrido realizado',
    'synthesis.missions': 'Misiones cumplidas',
    'synthesis.phrases': 'Mis frases favoritas',
    'synthesis.engagement': 'Mi compromiso',
    'synthesis.engagementPrompt': 'A mi vez, me comprometo a…',
    'synthesis.engagementPlaceholder': '…ayudar a alguien a empezar, como Eliano me ayudó.',
    'synthesis.engagementSave': 'Grabar mi compromiso',
    'synthesis.engagementSaved': 'Tu compromiso queda grabado en tu historia.',
    'footer.faq': 'FAQ',
    'chapter.notFound': 'Capítulo no encontrado',
    'chapter.keyValidated': 'Clave validada: +{value} puntos',
    'chapter.score': '{score} / 100 — recorrido del capítulo',
    'chapter.done': 'Terminado',
    'chapter.intro': 'Entra en el Espacio Legado: 10 claves te esperan.',
    'chapter.closingWord': 'La palabra final',
    'chapter.song': 'Canción oficial: {title}',
    'chapter.authorNote': 'Mirada del autor',
    'chapter.completeBtn': '¡He terminado este capítulo!',
    'chapter.completeNext': '¡Capítulo terminado! El siguiente está desbloqueado.',
    'chapter.completeDone': '¡Capítulo terminado, bravo!',
    'keys.coeur.title': 'En el corazón de Eliano',
    'keys.sagesse.title': 'Las semillas de sabiduría',
    'keys.phrase.title': 'La frase que queda',
    'keys.mentor.title': 'La mirada del mentor',
    'keys.dialogue.title': 'Hablemos de ello',
    'keys.mission.title': 'La misión de Eliano',
    'keys.carnet.title': 'El diario de Eliano',
    'keys.giveback.title': 'Give Back',
    'keys.aventure.title': 'Continúa la aventura',
    'keys.projection.title': 'Antes de pasar la página',
    'keys.coeur.question': '¿Qué emociones sentiste tú también?',
    'keys.coeur.action': 'Identifiqué mis emociones',
    'keys.coeur.toast': '¡Tus emociones están anotadas!',
    'keys.sagesse.question': 'Toca las semillas que quieres guardar:',
    'keys.sagesse.action': 'Guardo estas semillas',
    'keys.sagesse.toast': '¡Semillas guardadas!',
    'keys.phrase.action': 'Guardo esta frase',
    'keys.phrase.toast': '¡Frase guardada en tus favoritas!',
    'keys.mentor.letterFrom': 'Una carta de {name}',
    'keys.mentor.action': 'He leído la carta',
    'keys.mentor.toast': '¡Carta del mentor leída!',
    'keys.dialogue.action': 'Diálogo realizado (5-15 min)',
    'keys.dialogue.toast': '¡Buen diálogo!',
    'keys.mission.started': 'Misión empezada (+5)',
    'keys.mission.startedToast': '¡Misión empezada: +5!',
    'keys.mission.done': 'Misión cumplida (+10)',
    'keys.mission.doneToast': '¡Misión cumplida, bravo!',
    'keys.carnet.writes': 'Eliano escribe:',
    'keys.carnet.promptDefault': '¿Y tú? Hoy he entendido que...',
    'keys.carnet.placeholder': 'Hoy he entendido que…',
    'keys.carnet.encrypted': 'Tu escrito está cifrado: solo tú puedes leerlo.',
    'keys.carnet.action': 'Escribir en mi diario',
    'keys.carnet.toast': '¡Escrito en tu diario secreto!',
    'keys.giveback.photoAlt': 'Mi foto Give Back',
    'keys.giveback.changePhoto': 'Cambiar la foto',
    'keys.giveback.addPhoto': 'Añadir una foto de mi acción',
    'keys.giveback.withoutPhoto': 'Validar sin foto',
    'keys.giveback.photoToast': '¡Foto de tu acción añadida — Give Back validado!',
    'keys.giveback.toast': '¡Give Back realizado — la transmisión está en marcha!',
    'keys.giveback.uploadError': 'Error al enviar',
    'keys.aventure.action': 'Exploré los contenidos',
    'keys.aventure.toast': '¡Buena exploración!',
    'keys.projection.placeholder': 'Tu respuesta…',
    'keys.projection.action': 'Estoy listo/a para lo que sigue',
    'keys.projection.toast': '¡Listo/a para lo que viene!',
    'educator.title': 'Espacio del responsable',
    'educator.subtitle': 'Vista agrupada de tus jóvenes — hola {name}.',
    'educator.groupLabel': 'Grupo:',
    'educator.allYouths': 'Todos los jóvenes',
    'educator.newGroup': 'Nuevo grupo',
    'educator.edit': 'Modificar',
    'educator.delete': 'Eliminar',
    'educator.activeYouths': 'Jóvenes activos',
    'educator.avgProgress': 'Progreso medio',
    'educator.groupRadar': 'Rueda media del grupo',
    'educator.perYouth': 'Detalle por joven',
    'educator.emptyAll': 'Ningún joven en tus grupos por el momento — crea un grupo y añade jóvenes por email, o invítalos con tus códigos: aparecerán automáticamente en « Mis jóvenes ».',
    'educator.myCode': 'Mi código de invitación para jóvenes',
    'educator.myCodeHelp': 'Comparte este código: los jóvenes que se registren con él aparecerán automáticamente en tu grupo « Mis jóvenes ».',
    'educator.myCodeUses': '{n}/{max} usos',
    'educator.generateCode': 'Generar mi código',
    'educator.codeCreated': '¡Código generado!',
    'educator.emptyGroup': 'Este grupo está vacío — añade jóvenes con « Modificar ».',
    'educator.editGroup': 'Modificar el grupo',
    'educator.groupName': 'Nombre del grupo',
    'educator.groupNamePlaceholder': 'ej.: U12 — FC Valombre',
    'educator.groupEmails': 'Emails de los jóvenes (uno por línea — solo cuentas activas)',
    'educator.groupEmailsNote': 'Los jóvenes deben tener una cuenta activa (inscripción validada por su padre/madre).',
    'educator.save': 'Guardar',
    'educator.unresolved': '{n} email(s) no encontrado(s) o cuenta no activa: {list}',
    'educator.saved': '¡Grupo guardado!',
    'educator.deleted': 'Grupo eliminado',
    'educator.detailProgress': '{done}/{total} capítulos completados — {percent}% de las experiencias del Legado',
    'educator.diaryPrivate': 'El diario personal del joven permanece cifrado e invisible.',
    'educator.deleteTitle': '¿Eliminar este grupo?',
    'educator.deleteText': 'El grupo se eliminará, pero las cuentas de los jóvenes no se ven afectadas.',
    'admin.subtitle': 'Contenido del libro, códigos de invitación, solicitudes de acceso, usuarios y auditoría.',
    'admin.tabChapters': 'Capítulos',
    'admin.tabCodes': 'Códigos',
    'admin.tabRequests': 'Solicitudes',
    'admin.tabAmbassadors': 'Embajadores',
    'admin.tabMasterclass': 'Rendez-vous OCQJ !',
    'admin.tabQrcodes': 'Códigos QR',
    'admin.tabUsers': 'Usuarios',
    'admin.tabAudit': 'Auditoría',
    'admin.chaptersCount': '{n} capítulos',
    'admin.newChapter': 'Nuevo capítulo',
    'admin.colTitle': 'Título',
    'admin.colAct': 'Acto',
    'admin.colPublished': 'Publicado',
    'admin.chapterSaved': '¡Capítulo guardado!',
    'admin.chapterError': 'Error (revisa el JSON de canción/claves)',
    'admin.chapterDeleted': 'Capítulo eliminado',
    'admin.chapterDeleteConfirm': '¿Eliminar este capítulo?',
    'admin.chapterDeleteText': 'El capítulo {n} se eliminará definitivamente de la plataforma.',
    'admin.role': 'Rol',
    'admin.count': 'Cantidad',
    'admin.generate': 'Generar',
    'admin.codesGenerated': '{n} código(s) generado(s)',
    'admin.colCode': 'Código',
    'admin.colUses': 'Usos',
    'admin.colActive': 'Activo',
    'admin.colName': 'Nombre',
    'admin.colEmail': 'Email',
    'admin.colMessage': 'Mensaje',
    'admin.colStatus': 'Estado',
    'admin.colOrganisation': 'Organización',
    'admin.statusPending': 'Pendiente',
    'admin.statusApproved': 'Aceptada',
    'admin.statusRejected': 'Rechazada',
    'admin.requestsEmpty': 'Ninguna solicitud de acceso por el momento.',
    'admin.approveTitle': 'Aceptar y enviar un código',
    'admin.rejectTitle': 'Rechazar',
    'admin.requestDeleteTitle': 'Eliminar',
    'admin.requestDeleteConfirm': '¿Eliminar definitivamente esta solicitud? Esta acción es irreversible.',
    'admin.requestDeleted': 'Solicitud eliminada',
    'admin.codeSent': 'Código {code} enviado por email',
    'admin.requestRejected': 'Solicitud rechazada',
    'admin.ambassadorsEmpty': 'Ninguna candidatura por el momento.',
    'admin.ambassadorApproved': 'Embajador aceptado — email de bienvenida enviado',
    'admin.ambassadorRejected': 'Candidatura rechazada',
    'admin.ambassadorApproveTitle': 'Aceptar (email de bienvenida)',
    'admin.mcCount': '{n} rendez-vous',
    'admin.newMc': 'Nuevo rendez-vous',
    'admin.colDate': 'Fecha',
    'admin.colLocation': 'Lugar',
    'admin.colRegistrations': 'Inscritos',
    'admin.colActiveF': 'Activa',
    'admin.online': 'En línea',
    'admin.seeRegs': '{count}/{capacity} — ver',
    'admin.mcEmpty': 'Ningún rendez-vous — ¡crea el primero!',
    'admin.mcSaved': '¡Rendez-vous guardado!',
    'admin.mcError': 'Error (revisa la fecha)',
    'admin.mcDeleted': 'Rendez-vous eliminado',
    'admin.mcEdit': 'Modificar el rendez-vous',
    'admin.mcTitle': 'Título',
    'admin.mcTitlePlaceholder': 'ej.: El liderazgo con Dimitri',
    'admin.mcDescription': 'Descripción',
    'admin.mcDate': 'Fecha y hora',
    'admin.mcCapacity': 'Capacidad',
    'admin.mcLocation': 'Lugar (vacío = en línea)',
    'admin.mcLocationPlaceholder': 'ej.: Estadio municipal, Lyon',
    'admin.mcActive': 'Visible y abierta a inscripciones',
    'admin.regsTitle': 'Inscritos — {title}',
    'admin.regsEmpty': 'Ningún inscrito por el momento.',
    'admin.qrInfo': 'Cada código QR apunta a la URL limpia del capítulo (<dominio>/chapitre/N) — para imprimir en el libro. El joven deberá estar conectado para abrir el capítulo.',
    'admin.qrChapter': 'Cap. {n}',
    'admin.resendTitle': 'Reenviar el email de consentimiento al padre/madre',
    'admin.consentResent': 'Email de consentimiento reenviado al padre/madre de {name}',
    'admin.userDeleteTitle': 'Eliminar la cuenta y sus datos (RGPD)',
    'admin.userDeleted': 'Cuenta eliminada (datos borrados)',
    'admin.userDeleteDialogTitle': '¿Eliminar esta cuenta?',
    'admin.userDeleteDialogText': 'La cuenta de {name} ({email}) y todos sus datos (diario, progreso, inscripciones) se borrarán definitivamente. Acción irreversible (RGPD).',
    'admin.deleteForever': 'Eliminar definitivamente',
    'admin.colActor': 'Actor',
    'admin.colAction': 'Acción',
    'admin.colDetails': 'Detalles',
    'admin.chapterEdit': 'Modificar el capítulo {n}',
    'admin.chapterNumber': 'Número',
    'admin.chapterActPlaceholder': 'Acto I — El fuego de los primeros sueños',
    'admin.chapterSubtitle': 'Gancho (subtítulo)',
    'admin.chapterClosing': 'Palabra final',
    'admin.chapterAuthor': 'Mirada del autor',
    'admin.chapterSong': 'Canción oficial (JSON: title, style, lyrics)',
    'admin.chapterKeys': '10 claves del Legado (JSON: coeur, sagesse, phrase, mentor, dialogue, mission, carnet, giveback, aventure, projection)',
    'share.wheel': 'Compartir mi Rueda',
    'share.title': 'Mi Rueda del Legado',
    'share.downloaded': '¡La imagen de tu Rueda se ha descargado!',
    'share.error': 'No se puede compartir por el momento',
    'share.text': '¡Mi Rueda del Legado — {percent}% del recorrido realizado!',
    'faq.eyebrow': 'FAQ y testimonios',
    'faq.title': 'Preguntas frecuentes',
    'faq.intro': 'Todo lo que hay que saber para unirse y vivir la aventura de Eliano.',
    'faq.q1': '¿Cómo unirse a la aventura?',
    'faq.a1': 'Con el código del libro, un código de invitación de un responsable, o pidiendo un acceso gratuito desde la página de inicio.',
    'faq.q2': '¿A partir de qué edad?',
    'faq.a2': 'La aventura está pensada para los 8-15 años, en familia o en el club. La cuenta de un joven siempre se activa con la autorización de un padre o madre.',
    'faq.q3': '¿Quién puede leer el diario de mi hijo/a?',
    'faq.a3': 'Nadie más que él/ella. El diario está cifrado: ni los padres, ni los educadores, ni el equipo pueden leerlo.',
    'faq.q4': '¿Qué es la Rueda del Legado?',
    'faq.a4': 'Un radar de 10 ramas que crece con las experiencias vividas (emociones, misiones, diálogos…). Nunca es una nota: es un mapa de progreso.',
    'faq.q5': '¿Qué son los Give Back?',
    'faq.a5': 'Acciones de transmisión: cada joven que crece ayuda a otro a empezar — compartir el libro, entrenar a un menor, contar la historia.',
    'faq.q6': '¿Mis datos están seguros?',
    'faq.a6': 'Sí: alojamiento europeo, conformidad RGPD, exportación y supresión de tus datos en un clic desde « Mi cuenta ».',
    'faq.q7': '¿Cómo participar en un Rendez-vous OCQJ?',
    'faq.q8': '¿Cuándo tiene lugar la campaña de crowdfunding en Ulule?',
    'faq.a8': 'Del 4 de septiembre al 7 de noviembre de 2026. Las recompensas incluyen el libro, recursos educativos, Rendez-vous OCQJ e iniciativas Give Back. El botón «Apoyar el proyecto» de la portada te lleva allí.',
    'faq.q9': 'Aún no tengo código: ¿cómo mantenerme informado?',
    'faq.a9': 'Rellena el formulario «¿Quieres seguir la aventura?» de la página de inicio: indica tu perfil (lector, padre/madre, jugador, club, periodista, socio, embajador) y lo que te interesa (el libro, un Rendez-vous OCQJ o ambos). Recibirás las novedades antes que nadie.',
    'faq.q10': '¿Dónde introduzco el código de invitación de mi libro?',
    'faq.a10': 'Durante la campaña (hasta el 10 de noviembre de 2026), el formulario de código está en la página «El libro». Después volverá a la página de inicio.',
    'faq.q11': 'Soy periodista o socio: ¿dónde encuentro los materiales oficiales?',
    'faq.a11': 'La página «Prensa» ofrece el dossier de prensa y los visuales oficiales (flyer, banner, cubierta completa, ficha del autor). La página «Medios» ofrece el dossier de colaboración, la guía para padres y jóvenes y las tarjetas para redes sociales.',
    'faq.q12': 'Represento a un club de fútbol: ¿cómo unirme a los constructores?',
    'faq.a12': 'Selecciona el perfil «Un club de fútbol» en el formulario de inicio, descarga el dossier de colaboración desde el bloque «Busco constructores» y solicita tu acceso vía «Convertirse en socio».',
    'faq.a7': 'Los Rendez-vous OCQJ ! se anuncian en la página Rendez-vous OCQJ. Crea una cuenta e inscríbete en un clic.',
    'faq.testimonialsTitle': 'Ellos viven la aventura',
    'faq.t1Quote': 'Mi hijo relee sus misiones cada noche. La plataforma transformó su lectura en un proyecto de vida.',
    'faq.t1Author': 'Sophie, mamá de Léa (10 años)',
    'faq.t2Quote': 'Las 10 claves dan un marco concreto para hablar de valores con mis U12.',
    'faq.t2Author': 'Claire, educadora deportiva',
    'faq.t3Quote': 'Entendí que incluso los campeones fracasan. Ahora me atrevo.',
    'faq.t3Author': 'Noah, 11 años',
    'crm.title': 'CRM Prospección',
    'crm.subtitle': 'Base de contactos, pipeline y campañas de correo.',
    'crm.tabDashboard': 'Panel',
    'crm.tabContacts': 'Contactos',
    'crm.tabPipeline': 'Pipeline',
    'crm.tabCampaigns': 'Campañas',
    'crm.tabTemplates': 'Plantillas',
    'crm.kpiContacts': 'Contactos',
    'crm.kpiSent': 'Emails enviados',
    'crm.kpiEngaged': 'Compromiso',
    'crm.kpiRelances': 'Por relanzar',
    'crm.contactRate': 'Contactos alcanzados',
    'crm.engagementRate': 'Tasa de compromiso',
    'crm.funnelTitle': 'Embudo del pipeline',
    'crm.byCategory': 'Contactos por categoría',
    'crm.importBtn': 'Importar el archivo Excel',
    'crm.importDone': '{imported} contactos importados ({duplicates} duplicados, {skipped} sin email)',
    'crm.searchPlaceholder': 'Buscar (nombre, organización, email)…',
    'crm.allCategories': 'Todas las categorías',
    'crm.allStages': 'Todas las etapas',
    'crm.newContact': 'Nuevo contacto',
    'crm.detailTitle': 'Ficha de contacto',
    'crm.notes': 'Notas e historial',
    'crm.notePlaceholder': 'Nota interna…',
    'crm.moveTo': 'Mover a',
    'crm.deleteContact': '¿Eliminar este contacto?',
    'crm.deleteContactText': 'El contacto, sus notas y su historial de mensajes se eliminarán definitivamente.',
    'crm.unsubscribedBadge': 'Dado de baja',
    'crm.lastSent': 'Último envío',
    'crm.relancesTitle': 'Por relanzar',
    'crm.relancesEmpty': 'Ninguna relanzamiento pendiente — todo está al día.',
    'crm.daysAgo': 'hace {n} d (relance a día {d})',
    'crm.newCampaign': 'Nueva campaña',
    'crm.campaignName': 'Nombre de la campaña',
    'crm.campaignTemplate': 'Plantilla',
    'crm.campaignSegment': 'Segmento (vacío = todos los contactos con email)',
    'crm.campaignLang': 'Idioma del email',
    'crm.create': 'Crear',
    'crm.generate': 'Generar los mensajes',
    'crm.generated': '{n} mensajes generados',
    'crm.launch': 'Lanzar el envío',
    'crm.launchTitle': '¿Lanzar el envío de la campaña?',
    'crm.launchText': 'Se enviarán {n} emails en pequeños lotes (unas 40/minuto). Esta acción es definitiva.',
    'crm.cancelCampaign': 'Cancelar la campaña',
    'crm.cancelText': 'Los {n} mensajes pendientes se eliminarán.',
    'crm.previewSubject': 'Asunto',
    'crm.statusDraft': 'Borrador',
    'crm.statusGenerated': 'Lista',
    'crm.statusSending': 'Enviando…',
    'crm.statusDone': 'Terminada',
    'crm.statusCancelled': 'Cancelada',
    'crm.statusError': 'Error',
    'crm.templatesIntro': 'Plantillas del kit editorial — modificables. Variables: {Prenom}, {Institution}, {Fonction}, {Email}.',
    'crm.editTemplate': 'Modificar la plantilla',
    'crm.subjectFr': 'Asunto (FR)',
    'crm.bodyFr': 'Cuerpo (FR)',
    'crm.subjectEn': 'Asunto (EN)',
    'crm.bodyEn': 'Cuerpo (EN)',
    'crm.relanceDays': 'Relanzar tras (días)',
    'crm.savedTemplate': '¡Plantilla guardada!',
    'crm.saved': '¡Guardado!',
    'crm.deleted': 'Contacto eliminado.',
    'crm.deleteCampaign': 'Eliminar campaña',
    'crm.deleteCampaignText': 'La campaña y sus {n} mensajes se eliminarán definitivamente.',
    'crm.campaignDeleted': 'Campaña eliminada.',
    'footer.contact': 'Contacto',
    'crm.dmOpen': 'Mensaje directo',
    'crm.dmTitle': 'Escribir un mensaje directo',
    'crm.dmRecipient': 'Destinatario (email)',
    'crm.dmRecipientHelp': 'Busca un usuario o contacto existente, o escribe un nuevo email.',
    'crm.dmSubject': 'Asunto',
    'crm.dmBody': 'Tu mensaje…',
    'crm.dmLang': 'Idioma',
    'crm.dmSend': 'Enviar',
    'crm.dmSent': '¡Mensaje en cola de envío — saldrá en unos minutos!',
    'crm.dmInvalid': 'Se requieren un email válido, un asunto y un mensaje.',
    'contact.eyebrow': 'Hablemos',
    'contact.title': 'Contáctanos',
    'contact.intro': '¿Una pregunta sobre el libro, un Rendez-vous OCQJ que organizar, una colaboración que imaginar? Escríbenos: cada mensaje se lee con atención.',
    'contact.directTitle': 'En directo',
    'contact.reply48': 'Dimitri responde personalmente a cada mensaje, normalmente en 48 horas.',
    'contact.name': 'Tu nombre',
    'contact.phone': 'Tu teléfono',
    'contact.email': 'Tu email',
    'contact.subjectLabel': 'Tu mensaje trata sobre…',
    'contact.subject.livre': 'El libro',
    'contact.subject.masterclass': 'Un Rendez-vous OCQJ !',
    'contact.subject.partenariat': 'Una colaboración',
    'contact.subject.presse': 'La prensa',
    'contact.subject.autre': 'Otra cosa',
    'contact.message': 'Tu mensaje…',
    'contact.submit': 'Enviar el mensaje',
    'contact.success': '¡Mensaje recibido!',
    'contact.successSub': 'Gracias por tu confianza — Dimitri te responderá personalmente muy pronto.',
    'contact.error': 'Se ha producido un error — inténtalo de nuevo o escribe directamente a dimitri.mfoumou@gmail.com.',
    'crm.campaignCreated': 'Campaña creada',
    'crm.launched': 'Envío lanzado — los emails salen por lotes.',
    'crm.stage.a_contacter': 'Por contactar',
    'crm.stage.envoye': 'Email enviado',
    'crm.stage.relance': 'Relanzado',
    'crm.stage.discussion': 'En discusión',
    'crm.stage.gagne': 'Socio ganado',
    'crm.stage.sans_suite': 'Sin seguimiento',
    'crm.msgPending': 'Pendiente',
    'crm.msgSending': 'Enviando…',
    'crm.msgSent': 'Enviado',
    'crm.msgFailed': 'Fallo',
    'crm.colContact': 'Contacto',
    'crm.colCategory': 'Categoría',
    'crm.colStage': 'Etapa',
    'crm.colEmail': 'Email',
    'crm.page': 'Página {page}/{pages}',
  },
};
